import { useEffect, useState, useCallback, useRef } from "react";
import "./pos.css";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "../../redux/apiCalls";
import { userRequest } from "../../requestMethods";
import { publicRequest } from "../../requestMethods";
import {
    addProduct,
    addQuantityIcon,
    clearCart,
    replaceCartProductAtIndex,
} from "../../redux/cartRedux";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import createIpohInvoice from "../../components/pdf/createIpohInvoice";
import { useHistory } from "react-router";
import { generateSignature } from "../../redux/apiCalls";
import axios from "axios";
import moment from "moment";
import { isIpohAccountUser } from "../../utils/ipohAccount";
import { ORDER_FORM_PAYMENTS } from "../../constants/paymentSlots";
import {
    ipohAwningFieldsFromCode,
    resolveIpohAwningOrderFields,
} from "../../constants/ipohAwningCode";
import useIndoorSalesmanOptions from "../../Hooks/useIndoorSalesmanOptions";
import {
    buildTotalCostBreakdown,
    getTotalCostBreakdownInputs,
    getTotalCostBreakdownSum,
} from "../../utils/totalCostBreakdown";
import {
    FiShoppingCart,
    FiFileText,
    FiUser,
    FiActivity,
    FiArrowLeft,
    FiClipboard,
    FiPackage,
    FiSettings,
    FiBook,
    FiTrendingUp,
    FiMenu,
} from "react-icons/fi";
import { Close } from "@material-ui/icons";
import { capitalizeTextInputOnChange } from "../../utils/capitalizeTextInput";

// Import tab components
import OrderInfoTab from "./tabs/OrderInfoTab";
import ProductsTab from "./tabs/ProductsTab";
import PurchaseOrderTab from "./tabs/PurchaseOrderTab";
import ProductionTab from "./tabs/ProductionTab";
import CustomerTab from "./tabs/CustomerTab";
import BlueprintTab from "./tabs/BlueprintTab";
import SurveyTab from "./tabs/SurveyTab";
import HistoryTab from "./tabs/HistoryTab";
import JournalTab from "./tabs/JournalTab";

// Import modal components
import ProductPickerModal from "./components/ProductPickerModal";
import BlueprintUploadModal from "./components/BlueprintUploadModal";
import ProcessFlowChart from "./components/ProcessFlowChart";
import { validateOrderAddressLines, getAddressLineInputError } from "../../utils/orderAddressValidation";
import { buildWarrantyPayload } from "../../utils/buildOrderWarranties";

/** Split order `items` array into ProductPickerModal awning category buckets */
function groupAwningItemsFromColorItems(items) {
    const empty = {
        glassRoof: [],
        aluminumComposite: [],
        aluminiumCBond: [],
        polycarbonate: [],
        metalDeck: [],
        aluminiumStrip: [],
        retractableSystem: [],
    };
    if (!items || !Array.isArray(items)) return empty;
    items.forEach((item) => {
        const t = item.type;
        const clone = { ...item };
        if (t === "glass") empty.glassRoof.push(clone);
        else if (t === "aluminiumComposite") empty.aluminumComposite.push(clone);
        else if (t === "aluminiumCBond") empty.aluminiumCBond.push(clone);
        else if (t === "polyCarbonate") empty.polycarbonate.push(clone);
        else if (t === "metalDeck") empty.metalDeck.push(clone);
        else if (t === "aluminiumStrip") empty.aluminiumStrip.push(clone);
        else if (t === "retractableSystem") empty.retractableSystem.push(clone);
    });
    return empty;
}

const resolveMaterialMeasurements = (material) => {
    if (material?.measurements != null && String(material.measurements).trim() !== "") {
        return String(material.measurements);
    }

    const purchaseOrder = material?.purchaseOrderId;
    if (purchaseOrder && Array.isArray(purchaseOrder.materials)) {
        const itemCode = material.itemCode || material.code;
        const type = material.type || material.model;
        const poMatch = purchaseOrder.materials.find((poMaterial) => {
            const poItemCode = poMaterial.itemCode || poMaterial.code;
            const poType = poMaterial.type || poMaterial.model;
            return poItemCode === itemCode && poType === type;
        });
        if (poMatch?.measurements != null && String(poMatch.measurements).trim() !== "") {
            return String(poMatch.measurements);
        }
    }

    return "";
};

export default function EditOrder() {
    const dispatch = useDispatch();
    const history = useHistory();

    // Get order ID from URL
    const orderId = window.location.pathname.split("/").pop();


    const products = useSelector((state) => state.product.products);
    const [activeTab, setActiveTab] = useState("progression");
    const hasAppliedRoleDefaultTab = useRef(false);
    const [tabsMenuOpen, setTabsMenuOpen] = useState(false);
    const [isMobileTabs, setIsMobileTabs] = useState(typeof window !== "undefined" && window.innerWidth <= 768);
    const [colorpicker, setColorPicker] = useState(false);
    const [cashierMode, setCashierMode] = useState("sales");
    const [usersData, setUsersData] = useState([]);
    
    // Product mappings from database
    const [materialsData, setMaterialsData] = useState([]);
    const [productMappings, setProductMappings] = useState({
        acpMapping: {},
        glassMapping: {},
        polyMapping: {},
        aluminiumMapping: {},
        metalDeckMapping: {},
        steelHollowMapping: {},
        pvcGutterMapping: {},
        flashingMapping: {},
        aluminumStripCeilingMapping: {},
        addOnMapping: {},
    });
    const [vehiclesData, setVehiclesData] = useState([]);
    const [cashiersData, setCashiersData] = useState([]);
    const [artistsData, setArtistsData] = useState([]);
    const [producersData, setProducersData] = useState([]);
    const [installersData, setInstallersData] = useState([]);
    const [purchasersData, setPurchasersData] = useState([]);
    const [productionManagersData, setProductionManagersData] = useState([]);
    const [companiesData, setCompaniesData] = useState([]);
    const [name, setName] = useState("");
    const [inputs, setInputs] = useState({
        isProduct: true,
        billingSameAsAddress: false,
        sstIncluded: false,
        billingLineOne: "",
        billingLineTwo: "",
        billingZip: "",
        billingCity: "",
        billingCountry: "",
    });
    const [orderInfo, setOrderInfo] = useState({
        artist: null,
        producer: null,
        installer: null,
        purchaser: null,
        productionManager: null,
        cashier: null,
        secondSalesperson: "",
        status: "",
        createdAt: "",
        commenceDate: "",
        uploadedDraftDate: "",
        blueprintApprovalDate: "",
        salesmanApprovedDate: "",
        salesmanRejectedDate: "",
        customerApprovedDate: "",
        pendingPurchaseApprovalDate: "",
        purchasingDate: "",
        productionDate: "",
        productionApprovalDate: "",
        installingDate: "",
        installApprovedDate: "",
        depositDate: "",
        surveyDate: "",
        lineOne: "",
        lineTwo: "",
        zip: "",
        city: "",
        country: "",
        threeDPrint: false,
        threedDrawing: 0,
    });

    const [addBlueprintModalState, setAddBlueprintModalState] = useState(false);
    const [isUploadingBlueprint, setIsUploadingBlueprint] = useState(false);
    const [isSavingSurvey, setIsSavingSurvey] = useState(false);
    const [pendingMode, setPendingMode] = useState(false);
    const [checkedBlueprints, setCheckedBlueprints] = useState({});
    const [approveDraftModalState, setApproveDraftModalState] = useState(false);
    const [rejectDraftModalState, setRejectDraftModalState] = useState(false);
    const [salesmanApproveModalState, setSalesmanApproveModalState] = useState(false);
    const [salesmanRejectModalState, setSalesmanRejectModalState] = useState(false);
    const [customerApproveModalState, setCustomerApproveModalState] = useState(false);
    const [customerRejectModalState, setCustomerRejectModalState] = useState(false);
    const [approveProductionModalState, setApproveProductionModalState] = useState(false);
    const [rejectProductionModalState, setRejectProductionModalState] = useState(false);
    const [approveInstallationModalState, setApproveInstallationModalState] = useState(false);
    const [submitDraftModalState, setSubmitDraftModalState] = useState(false);
    const [submitPurchaseOrderModalState, setSubmitPurchaseOrderModalState] = useState(false);
    const [approvePurchaseOrderModalState, setApprovePurchaseOrderModalState] = useState(false);
    const [rejectPurchaseOrderModalState, setRejectPurchaseOrderModalState] = useState(false);
    const [completePurchaseModalState, setCompletePurchaseModalState] = useState(false);
    const [confirmPOArrivedModalState, setConfirmPOArrivedModalState] = useState(false);
    const [submitProductionModalState, setSubmitProductionModalState] = useState(false);
    const [completeProductionModalState, setCompleteProductionModalState] = useState(false);
    const [confirmProductionCompletedModalState, setConfirmProductionCompletedModalState] = useState(false);
    const [deleteBlueprintModalState, setDeleteBlueprintModalState] = useState(false);
    const [deleteBlueprintData, setDeleteBlueprintData] = useState(null);
    const [confirmCompletedModalState, setConfirmCompletedModalState] = useState(false);
    const [isConfirmingCompleted, setIsConfirmingCompleted] = useState(false);
    const [commenceDate, setCommenceDate] = useState("");
    const [productionCommenceDate, setProductionCommenceDate] = useState("");
    const [installationCommenceDate, setInstallationCommenceDate] = useState("");
    const [surveyData, setSurveyData] = useState({
        pricing: "",
        projectCompletion: "",
        qualityOfWork: "",
        communication: "",
        maintenance: "",
        starRating: "",
        comments: "",
        orderNumber: "",
        customerName: "",
        address: "",
        installerName: "",
        date: "",
        time: "",
        icNumber: "",
        signature: "",
        facebookReviewUrl: "",
        googleReviewUrl: "",
    });
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [signatureRef, setSignatureRef] = useState(null);
    const [customerSignatureRef, setCustomerSignatureRef] = useState(null);
    const [itemDetails, setItemDetails] = useState({
        name: undefined,
        price: undefined,
        type: "new",
    });

    const [product, setProduct] = useState({});
    const [color, setColor] = useState({});
    const [filterList, setFilterList] = useState({
        type: "watch",
    });
    const [productfilterCategory, setProductFilterCategory] = useState({
        status: "active",
        model: undefined,
        brand: undefined,
    });

    const cart = useSelector((state) =>
        state.cart ? state.cart.products : []
    );


    // Materials cart state (separate from products cart)
    const [materialsCart, setMaterialsCart] = useState([]);

    // Production usage cart state (similar to materials cart but for production)
    const [productionUsageCart, setProductionUsageCart] = useState([]);

    // Expenses state
    const [expensesData, setExpensesData] = useState({
        creditCard: 0.00,
        commission: 0.00,
        freeGive: 0.00,
        crane: 0.00,
        voucher: 0.00,
        drawing: 0.00,
        sponsor: 0.00,
        snSstCn: 0.00,
        swSstCn: 0.00,
        sstCn: 0.00,
        threedDrawing: 0.00,
        accessoryCosting: 0.00
    });

    const [cartLoaded, setCartLoaded] = useState(false);

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);
    const isIpohAccount = isIpohAccountUser(currentUser);
    const indoorSalesmanOptions = useIndoorSalesmanOptions(isIpohAccount);

    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const hq = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "HQ"
            : null
    );

    const artist = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "drafter"
            : null
    );

    const purchaser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "purchaser"
            : null
    );

    const production = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "production"
            : null
    );

    const productionManager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "productionManager"
            : null
    );

    // Extended production manager access for outright users and specific user ID
    const hasProductionManagerAccess = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "productionManager" ||
              state.user.currentUser.type === "installerManager" ||
              state.user.currentUser.type === "outright" ||
              state.user.currentUser._id === "693a66d612091dab660b5600" ||
              state.user.currentUser._id === "693a66b412091dab660b55fd"
            : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "staff"
            : null
    );

    const installer = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "installer"
            : null
    );

    const installerManager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "installerManager"
            : null
    );

    const isRegularUser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "user"
            : null
    );

    const NumberFormatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const total = useSelector((state) =>
        state.cart ? (state.cart.total ? state.cart.total : 0) : 0
    );

    let deconstructedProductList = [];
    cart.forEach((product) => {
        for (let i = 0; i < product.quantity; i++) {
            deconstructedProductList.push(product);
        }
    });

    // Motorized Zip Blinds Model to Item Code mapping
    const zipBlindsModelMapping = {
        'AZIP-0001': { type: 'Zip Blinds Lite 105', pricePerUnit: 0 },
        'AZIP-0002': { type: 'Zip Blinds Pro 130', pricePerUnit: 0 },
        'AZIP-0003': { type: 'Zip Blinds Pro 130 Plus', pricePerUnit: 0 },
        'AZIP-0004': { type: 'Zip Blinds Pro Max 135', pricePerUnit: 0 },
    };

    // Reverse mapping: Model to Item Code for Motorized Zip Blinds
    const modelToItemCodeZipBlinds = Object.fromEntries(
        Object.entries(zipBlindsModelMapping).map(([key, value]) => [value.type, key])
    );

    // Motorized Zip Blinds Fabric options
    const zipBlindsFabricOptions = [
        'Black 1% V2',
        'Dark Grey 1% V2',
        'Grey 1% V2',
        'Black 3%',
        'Dark Grey 3%',
        'Grey 3%',
        'Black 3% V2',
        'Dark Grey 3% V2',
        'Grey 3% V2',
        'Black 5%',
        'Dark Grey 5%',
        'Dark Grey 5% V2',
        'Black 5% V2',
    ];

    // Zip Blinds Manual Series Model to Item Code mapping
    const zipBlindsManualModelMapping = {
        'MZIP-0001': { type: 'J6 Series', pricePerUnit: 0 },
        'MZIP-0002': { type: 'J7 Series', pricePerUnit: 0 },
    };

    // Reverse mapping: Model to Item Code for Zip Blinds Manual Series
    const modelToItemCodeZipBlindsManual = Object.fromEntries(
        Object.entries(zipBlindsManualModelMapping).map(([key, value]) => [value.type, key])
    );

    // Zip Blinds Manual Series Color options
    const zipBlindsManualColorOptions = [
        'Matt Dark Grey',
        'Matt Black',
    ];

    // Zip Blinds Manual Series Transparency options
    const zipBlindsManualTransparencyOptions = [
        '0%',
        '1%',
        '5%',
        '10%',
        '30%',
        '50%',
        '100%',
    ];

    // Retractable Awning Model to Item Code mapping
    const retractableAwningModelMapping = {
        'AWN-0001': { type: 'Type B', pricePerUnit: 0 },
        'AWN-0002': { type: 'Type E', pricePerUnit: 0 },
        'AWN-0003': { type: 'Type FC', pricePerUnit: 0 },
    };

    // Reverse mapping: Model to Item Code for Retractable Awning
    const modelToItemCodeRetractableAwning = Object.fromEntries(
        Object.entries(retractableAwningModelMapping).map(([key, value]) => [value.type, key])
    );

    // Retractable Awning Fabric options
    const retractableAwningFabricOptions = [
        'Wave',
        'Flat',
        'Aolux',
        'Masacril',
    ];

    // Retractable Awning Fabric Color options
    const retractableAwningFabricColorOptions = [
        'F9101', 'F9102', 'F9103', 'F9401', 'F9501', 'F9201', 'F9202', 'F9301',
        'F9602', 'F9701', 'F9302', 'F9303', 'F9304', 'F9601', 'F9702', 'F9703',
        'F9801', 'F9802', 'F9825', 'F9830', 'F9805', 'F9806', 'F9808', 'F9842',
        'F9843', 'F9811', 'F9812', 'F9820', 'F9845', 'F9831', 'F9821', 'F9822',
        'F9824', 'F9844', '2013', '2050', '2170', '2427', '2146', '2246', '2235',
        '2018', '2101', '2596', '2209', '2038', '2102', '2211', '2042', '2065',
        '8488', '2245', '2145', '2316', '2815', '2154', '2119', '2701', '2216',
        '2015', '2121', '2816', '2680', '2212', '2120', '2360', '2575', '2702',
        '2179', '2576', '2238', '2251', '2818', '2063-',
    ];

    // Retractable Awning Side Panel Color options
    const retractableAwningSidePanelColorOptions = [
        'Noble Grey Solid Colour Finish',
        'Noble Grey Chrome Ring Finish',
        'Noble Grey Standard Wood Grain Finish',
        'Noble Grey Black Walnut Wood Grain Finish',
        'Pearl White Solid Colour Finish',
        'Pearl White Chrome Ring Finish',
        'Pearl White Standard Wood Grain Finish',
        'Pearl White Black Walnut Wood Grain Finish',
        'Cappuccino Solid Colour Finish',
        'Cappuccino Chrome Ring Finish',
        'Cappuccino Standard Wood Grain Finish',
        'Cappuccino Black Walnut Wood Grain Finish',
    ];

        // Prevent scroll from affecting number inputs and select fields
        useEffect(() => {
            const preventScrollOnNumberInput = (e) => {
                // Prevent scroll on focused number inputs
                if (document.activeElement.type === 'number') {
                    e.preventDefault();
                }
            };
    
            const preventScrollOnSelect = (e) => {
                // Prevent scroll on select elements
                if (document.activeElement.tagName === 'SELECT') {
                    e.preventDefault();
                }
            };
    
            // Add event listeners to prevent scroll
            const handleWheel = (e) => {
                preventScrollOnNumberInput(e);
                preventScrollOnSelect(e);
            };
    
            // Attach to all number inputs
            const numberInputs = document.querySelectorAll('input[type="number"]');
            numberInputs.forEach(input => {
                input.addEventListener('wheel', handleWheel, { passive: false });
                // Also blur on wheel to prevent accidental changes
                input.addEventListener('wheel', () => {
                    if (document.activeElement === input) {
                        input.blur();
                    }
                });
            });
    
            // Attach to all select elements
            const selectElements = document.querySelectorAll('select');
            selectElements.forEach(select => {
                select.addEventListener('wheel', handleWheel, { passive: false });
            });
    
            // Cleanup
            return () => {
                numberInputs.forEach(input => {
                    input.removeEventListener('wheel', handleWheel);
                });
                selectElements.forEach(select => {
                    select.removeEventListener('wheel', handleWheel);
                });
            };
        }, [activeTab]); // Re-run when tab changes to catch new inputs

    // Fetch order data
    const fetchOrderData = async () => {
        if (!orderId) return;

        try {
            setLoading(true);
            const res = await userRequest.get(`/orders/findOrder/${orderId}`);
            if (res.data) {
                setOrderData(res.data);
            }
        } catch (error) {
            console.error("Error fetching order:", error);
            alert("Failed to fetch order data");
        } finally {
            setLoading(false);
        }
    };

    const getUsers = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setUsersData(res.data);
    };

    const getCompanies = async () => {
        try {
            const filters = {
                status: "active",
                limit: 9999,
                page: 1,
            };
            const res = await publicRequest.get("/companies", {
                params: {
                    filters: JSON.stringify(filters)
                }
            });
            setCompaniesData(res.data?.companies || res.data || []);
        } catch (err) {
            console.error("Error fetching companies:", err);
        }
    };

    const getVehicles = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setVehiclesData(res.data);
    };

    const getCashiers = useCallback(async () => {
        let principleParam;

  if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {};
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/allcashiers", {
            params,
        });
        setCashiersData(res.data);
    }, [currentUser]);

    const getArtists = useCallback(async () => {
        let principleParam;

  if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "drafter",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setArtistsData(res.data);
    }, [currentUser]);

    const getProducers = useCallback(async () => {
        let principleParam;

        if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "production",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setProducersData(res.data);
    }, [currentUser]);

    const getInstallers = useCallback(async () => {
        let principleParam;

  if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "installer",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setInstallersData(res.data);
    }, [currentUser]);

    const getPurchasers = useCallback(async () => {
        let principleParam;

  if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "purchaser",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setPurchasersData(res.data);
    }, [currentUser]);

    const getProductionManagers = useCallback(async () => {
        let principleParam;

        if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        // Prepare params for both types
        const getUsersByType = async (type) => {
            const params = {
                type,
                isAdmin: true,
            };
            if (principleParam !== undefined) {
                params.principle = principleParam;
            }
            const res = await publicRequest.get("/users/admin", {
                params,
            });
            return res.data;
        };

        // Fetch for both types
        const [productionManagers, installationManagers] = await Promise.all([
            getUsersByType("productionManager"),
            getUsersByType("installerManager"),
        ]);

        // Merge, deduplicate by _id (optional but likely wanted)
        const mergedManagers = [
            ...productionManagers,
            ...installationManagers.filter(
                ins =>
                    !productionManagers.some(prod => prod._id === ins._id)
            ),
        ];

        setProductionManagersData(mergedManagers);
    }, [currentUser]);

    const handleChange = (e) => {
        const t = e.target;
        if (t.name === "warranty" && t.value && typeof t.value === "object") {
            setInputs((prev) => ({ ...prev, warranty: t.value }));
            return;
        }
        if (t.name === "billingSameAsAddress" && t.type === "checkbox") {
            setInputs((prev) => ({
                ...prev,
                billingSameAsAddress: t.checked,
                ...(t.checked
                    ? {
                          billingLineOne: prev.lineOne || "",
                          billingLineTwo: prev.lineTwo || "",
                          billingZip: prev.zip || "",
                          billingCity: prev.city || "",
                          billingCountry: prev.country || "",
                      }
                    : {}),
            }));
            return;
        }
        const addressLineError = getAddressLineInputError(t.name, t.value);
        if (addressLineError) {
            alert(addressLineError);
            return;
        }
        setInputs((prev) => ({ ...prev, [t.name]: t.value }));
    };

    useEffect(() => {
        if (inputs.billingSameAsAddress !== true) return;
        setInputs((prev) => ({
            ...prev,
            billingLineOne: prev.lineOne || "",
            billingLineTwo: prev.lineTwo || "",
            billingZip: prev.zip || "",
            billingCity: prev.city || "",
            billingCountry: prev.country || "",
        }));
    }, [
        inputs.billingSameAsAddress,
        inputs.lineOne,
        inputs.lineTwo,
        inputs.zip,
        inputs.city,
        inputs.country,
    ]);

    const handleSetItemDetails = (e) => {
        setItemDetails((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleInputCashier = (e) => {
        setInputs((prev) => {
            return { ...prev, cashier: e.value };
        });
    };

    const handleOrderInfoChange = (field, value) => {
        setOrderInfo((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSaveOrderInfo = async () => {
        const predata = orderData;

        if (currentUser) {
            try {
                const res = await userRequest.put(
                    `/orders/update/${predata._id}`,
                    {
                        status: orderInfo.status,
                        createdAt: orderInfo.createdAt,
                        commenceDate: orderInfo.commenceDate,
                        uploadedDraftDate: orderInfo.uploadedDraftDate,
                        blueprintApprovalDate: orderInfo.blueprintApprovalDate,
                        customerApprovedDate: orderInfo.customerApprovedDate,
                        pendingPurchaseApprovalDate: orderInfo.pendingPurchaseApprovalDate,
                        purchasingDate: orderInfo.purchasingDate,
                        productionDate: orderInfo.productionDate,
                        productionApprovalDate: orderInfo.productionApprovalDate,
                        installingDate: orderInfo.installingDate,
                        installApprovedDate: orderInfo.installApprovedDate,
                        depositDate: orderInfo.depositDate,
                        artist: orderInfo.artist ? orderInfo.artist._id : null,
                        producer: orderInfo.producer
                            ? orderInfo.producer._id
                            : null,
                        installer: orderInfo.installer
                            ? orderInfo.installer._id
                            : null,
                        purchaser: orderInfo.purchaser
                            ? orderInfo.purchaser._id
                            : null,
                        productionManager: orderInfo.productionManager
                            ? orderInfo.productionManager._id
                            : null,
                        productionManager: orderInfo.productionManager
                            ? orderInfo.productionManager._id
                            : null,
                        cashier: orderInfo.cashier
                            ? orderInfo.cashier._id
                            : null,
                        ...(isIpohAccount
                            ? { secondSalesperson: orderInfo.secondSalesperson || null }
                            : {}),
                        lineOne: orderInfo.lineOne,
                        lineTwo: orderInfo.lineTwo,
                        zip: orderInfo.zip,
                        city: orderInfo.city,
                        country: orderInfo.country,
                        threeDPrint: orderInfo.threeDPrint || false,
                        expenses: {
                            ...predata.expenses,
                            threedDrawing: orderInfo.threedDrawing || 0,
                        },
                        survey: {
                            ...predata.survey,
                            surveyDate: orderInfo.surveyDate || predata.survey?.surveyDate,
                        },
                    }
                );

                if (res.data) {
                    alert("Order information updated successfully!");
                    // Refresh order data
                    fetchOrderData();
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert("Failed to update order information. Please try again.");
                console.error(err);
            }
        } else {
            alert("Please login before saving");
        }
    };

    // Survey handling functions
    const handleSurveyChange = (field, value) => {
        setSurveyData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    // Expenses handling function
    const handleExpensesChange = (field, value) => {
        if (typeof field === 'object') {
            // If first parameter is an object (from ExpensesTab), use it directly
            setExpensesData(field);
        } else {
            // If it's a field name and value (from ProductsTab or POS), update individual field
            const numericValue = Math.max(0, parseFloat(value) || 0);
            setExpensesData(prev => ({
                ...prev,
                [field]: numericValue
            }));
        }
    };


    const clearSignature = () => {
        if (signatureRef) {
            const canvas = signatureRef;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            setSurveyData((prev) => ({ ...prev, signature: "" }));
        }
    };

    const handleSignatureEnd = () => {
        if (signatureRef) {
            const signatureData = signatureRef.toDataURL();
            setSurveyData((prev) => ({ ...prev, signature: signatureData }));
        }
    };

    const saveSurvey = async () => {
        setIsSavingSurvey(true);
        try {
            if (orderData && orderData._id && !staff) {
                const currentDate = surveyData.date || new Date().toISOString();
                const currentTime = surveyData.time || new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
                const customerIc = orderData.userId?.ic || surveyData.icNumber || "";
                
                const surveyPayload = {
                    pricing: surveyData.pricing,
                    projectCompletion: surveyData.projectCompletion,
                    qualityOfWork: surveyData.qualityOfWork,
                    communication: surveyData.communication,
                    maintenance: surveyData.maintenance,
                    starRating: parseInt(surveyData.starRating),
                    comments: surveyData.comments,
                    signature: surveyData.signature,
                    surveyDate: currentDate,
                    time: currentTime,
                    ic: customerIc,
                    facebookReview: surveyData.facebookReviewUrl ? { url: surveyData.facebookReviewUrl, status: orderData.survey?.facebookReview?.status || "pending" } : undefined,
                    googleReview: surveyData.googleReviewUrl ? { url: surveyData.googleReviewUrl, status: orderData.survey?.googleReview?.status || "pending" } : undefined,
                };

                const surveyDataToSave = { survey: surveyPayload };

                    surveyDataToSave.status = "installApproved";
                    surveyDataToSave.installApprovedDate = new Date().toISOString();


                const response = await userRequest.put(
                    `/orders/update/${orderData._id}`,
                    surveyDataToSave
                );

                if (response.data) {
                    setOrderData(prev => ({
                        ...prev,
                        survey: surveyPayload,
                        ...(surveyDataToSave.status ? { status: surveyDataToSave.status } : {}),
                        ...(surveyDataToSave.installApprovedDate ? { installApprovedDate: surveyDataToSave.installApprovedDate } : {})
                    }));
                    setSurveyData(prev => ({
                        ...prev,
                        date: currentDate,
                        time: currentTime,
                        icNumber: customerIc
                    }));
                    alert("Survey data saved successfully!");
                } else {
                    alert("Failed to save survey data");
                    setIsSavingSurvey(false);
                    return;
                }
            } else {
                alert("Survey data saved successfully!");
            }
        } catch (error) {
            console.error("Error saving survey data:", error);
            alert("Failed to save survey data. Please try again.");
        } finally {
            setIsSavingSurvey(false);
        }
    };

    const handleReviewStatusChange = async (reviewType, newStatus, skipConfirm = false, newUrl = null) => {
        if (!skipConfirm) {
            const actionText = newStatus === "approved" ? "approve" : "reject";
            const confirmMessage = `Are you sure you want to ${actionText} this ${reviewType} review?`;
            
            if (!window.confirm(confirmMessage)) {
                return;
            }
        }

        try {
            const reviewKey = reviewType === "facebook" ? "facebookReview" : "googleReview";
            const otherReviewKey = reviewType === "facebook" ? "googleReview" : "facebookReview";
            const surveyUrlKey = reviewType === "facebook" ? "facebookReviewUrl" : "googleReviewUrl";
            const otherSurveyUrlKey = reviewType === "facebook" ? "googleReviewUrl" : "facebookReviewUrl";
            const currentReview = orderData?.survey?.[reviewKey] || {};
            const otherReview = orderData?.survey?.[otherReviewKey] || {};
            
            const currentUrl = newUrl || surveyData[surveyUrlKey] || currentReview.url;
            const otherUrl = surveyData[otherSurveyUrlKey] || otherReview.url;
            
            const updatedReview = {
                ...currentReview,
                status: newStatus,
                url: currentUrl,
            };
            
            if (newStatus !== "pending") {
                updatedReview.approvedBy = currentUser._id;
                updatedReview.approvedDate = new Date().toISOString();
            }
            
            const otherReviewData = otherUrl ? {
                ...otherReview,
                url: otherUrl,
            } : otherReview;

            const updatePayload = {
                survey: {
                    ...orderData.survey,
                    [reviewKey]: updatedReview,
                    [otherReviewKey]: otherReviewData,
                },
            };

            const response = await userRequest.put(
                `/orders/${orderData._id}`,
                updatePayload
            );

            if (response.data) {
                setOrderData(prev => ({
                    ...prev,
                    survey: {
                        ...prev.survey,
                        [reviewKey]: updatedReview,
                        [otherReviewKey]: otherReviewData,
                    },
                }));
                setSurveyData(prev => ({
                    ...prev,
                    [surveyUrlKey]: currentUrl,
                    [otherSurveyUrlKey]: otherUrl || prev[otherSurveyUrlKey],
                }));
                if (!skipConfirm) {
                    alert(`${reviewType.charAt(0).toUpperCase() + reviewType.slice(1)} review ${newStatus === "approved" ? "approved" : "rejected"} successfully!`);
                }
            }
        } catch (error) {
            console.error(`Error updating ${reviewType} review status:`, error);
            alert(`Failed to update review status. Please try again.`);
        }
    };

    const generateSurveyPDFOnly = () => {
        // Use saved data from orderData.survey instead of local surveyData state
        const savedSurvey = orderData?.survey || {};
        const formattedAddress = [
            orderData?.lineOne,
            orderData?.lineTwo,
            orderData?.zip,
            orderData?.city,
            orderData?.country
        ].filter(Boolean).join(", ");

        // Create a new window for the PDF
        const printWindow = window.open("", "_blank");

        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Customer Satisfaction Survey</title>
                <meta charset="UTF-8">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    
                    * { box-sizing: border-box; }
                    
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                        margin: 0;
                        padding: 40px;
                        line-height: 1.6;
                        color: #1a1a1a;
                        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                        min-height: 100vh;
                    }
                    
                    .document-container {
                        max-width: 800px;
                        margin: 0 auto;
                        background: white;
                        border-radius: 12px;
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                    }
                    
                    .header-section {
                        background: rgb(246, 173, 85);
                        color: white;
                        padding: 40px;
                        text-align: center;
                        position: relative;
                        overflow: hidden;
                    }
                    
                    .header-section::before {
                        content: '';
                        position: absolute;
                        top: -50%;
                        right: -50%;
                        width: 200%;
                        height: 200%;
                        background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
                        animation: gentle-float 6s ease-in-out infinite;
                    }
                    
                    @keyframes gentle-float {
                        0%, 100% { transform: translate(0, 0) rotate(0deg); }
                        50% { transform: translate(-10px, -10px) rotate(5deg); }
                    }
                    
                    .company-name {
                        font-size: 28px;
                        font-weight: 700;
                        margin-bottom: 8px;
                        letter-spacing: -0.5px;
                        position: relative;
                        z-index: 2;
                    }
                    
                    .document-title {
                        font-size: 18px;
                        font-weight: 500;
                        opacity: 0.95;
                        margin-bottom: 0;
                        letter-spacing: 2px;
                        text-transform: uppercase;
                        position: relative;
                        z-index: 2;
                    }
                    
                    .content-section {
                        padding: 40px;
                    }
                    
                    .intro-card {
                        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
                        border-left: 4px solid #6366f1;
                        padding: 24px;
                        margin-bottom: 32px;
                        border-radius: 8px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                    }
                    
                    .intro-text {
                        color: #374151;
                        font-size: 14px;
                        line-height: 1.7;
                        margin: 0;
                    }
                    
                    .section-divider {
                        height: 2px;
                        background: linear-gradient(90deg, #6366f1, #8b5cf6, #6366f1);
                        margin: 32px 0;
                        border-radius: 1px;
                    }
                    
                    .criteria-section {
                        margin-bottom: 32px;
                    }
                    
                    .section-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1f2937;
                        margin-bottom: 16px;
                        display: flex;
                        align-items: center;
                    }
                    
                    .section-title::before {
                        content: '✦';
                        color: #6366f1;
                        margin-right: 8px;
                        font-size: 18px;
                    }
                    
                    .criteria-table { 
                        width: 100%;
                        border-collapse: separate;
                        border-spacing: 0;
                        margin-bottom: 24px;
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                    }
                    
                    .criteria-table th {
                        background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
                        color: white;
                        padding: 16px 12px;
                        font-weight: 600;
                        font-size: 12px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        text-align: center;
                        border: none;
                    }
                    
                    .criteria-table td {
                        padding: 14px 12px;
                        border-bottom: 1px solid #e5e7eb;
                        text-align: center;
                        font-size: 13px;
                        background: white;
                        transition: background-color 0.2s ease;
                    }
                    
                    .criteria-table tr:nth-child(even) td {
                        background: #f9fafb;
                    }
                    
                    .criteria-table tr:hover td {
                        background: #f3f4f6;
                    }
                    
                    .criteria-name { 
                        text-align: left !important;
                        font-weight: 500;
                        color: #374151;
                    }
                    
                    .rating-cell { 
                        width: 60px;
                        position: relative;
                    }
                    
                    .rating-mark { 
                        color: #059669;
                        font-size: 18px;
                        font-weight: 700;
                    }
                    
                    .comments-section {
                        background: #f8fafc;
                        border-radius: 8px;
                        padding: 24px;
                        margin: 24px 0;
                        border: 1px solid #e2e8f0;
                    }
                    
                    .comments-title {
                        font-weight: 600;
                        color: #374151;
                        margin-bottom: 12px;
                        font-size: 14px;
                    }
                    
                    .comments-content {
                        background: white;
                        padding: 16px;
                        border-radius: 6px;
                        border: 1px solid #d1d5db;
                        font-size: 13px;
                        line-height: 1.6;
                        color: #4b5563;
                        min-height: 60px;
                    }
                    
                    .form-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                        gap: 20px;
                        margin: 24px 0;
                    }
                    
                    .form-field {
                        background: #f8fafc;
                        border-radius: 8px;
                        padding: 16px;
                        border: 1px solid #e2e8f0;
                    }
                    
                    .field-label {
                        font-weight: 600;
                        color: #374151;
                        font-size: 12px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        margin-bottom: 6px;
                        display: block;
                    }
                    
                    .field-value {
                        color: #1f2937;
                        font-size: 14px;
                        font-weight: 500;
                        padding: 8px 0;
                        border-bottom: 2px solid #6366f1;
                        min-height: 24px;
                    }
                    
                    .signature-section {
                        margin: 32px 0;
                        padding: 24px;
                        background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
                        border-radius: 8px;
                        border: 1px solid #d1d5db;
                    }
                    
                    .signature-title {
                        font-weight: 600;
                        color: #374151;
                        margin-bottom: 16px;
                        font-size: 14px;
                    }
                    
                    .signature-box {
                        border: 2px dashed #9ca3af;
                        border-radius: 8px;
                        height: 120px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: white;
                        position: relative;
                    }
                    
                    .signature-box img {
                        max-height: 100px;
                        max-width: 300px;
                        border-radius: 4px;
                    }
                    
                    .no-signature {
                        color: #9ca3af;
                        font-style: italic;
                        font-size: 13px;
                    }
                    
                    .footer-section {
                        margin-top: 40px;
                        padding-top: 24px;
                        border-top: 2px solid #e5e7eb;
                        text-align: center;
                        color: #6b7280;
                        font-size: 12px;
                    }
                    
                    .print-buttons {
                        margin-top: 24px;
                        text-align: center;
                        gap: 12px;
                        display: flex;
                        justify-content: center;
                    }
                    
                    .btn {
                        padding: 12px 24px;
                        border: none;
                        border-radius: 8px;
                        font-weight: 600;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    
                    .btn-primary {
                        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
                        color: white;
                        box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
                    }
                    
                    .btn-primary:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 6px 16px rgba(99, 102, 241, 0.5);
                    }
                    
                    .btn-secondary {
                        background: #f3f4f6;
                        color: #374151;
                        border: 1px solid #d1d5db;
                    }
                    
                    .btn-secondary:hover {
                        background: #e5e7eb;
                        transform: translateY(-1px);
                    }
                    
                    @media print {
                        body { 
                            margin: 0; 
                            padding: 20px;
                            background: white;
                        }
                        .document-container {
                            box-shadow: none;
                            border-radius: 0;
                        }
                        .no-print { display: none !important; }
                        .header-section::before { display: none; }
                    }
                    
                    @media (max-width: 768px) {
                        body { padding: 20px; }
                        .content-section { padding: 24px; }
                        .header-section { padding: 24px; }
                        .company-name { font-size: 24px; }
                        .form-grid { grid-template-columns: 1fr; }
                    }
                </style>
            </head>
            <body>
                <div class="document-container">
                    <div class="header-section">
                        <div class="company-name">INHOME GROUP SDN BHD</div>
                        <div class="document-title">Customer Satisfaction Survey</div>
                    </div>
                    
                    <div class="content-section">
                        <div class="intro-card">
                            <p class="intro-text">
                                <strong>Dear Valued Client,</strong><br><br>
                                We strive to provide our clients with the highest possible level of services and projects. 
                                To continuously improve our services, we would appreciate your participation in this 
                                satisfaction survey by sharing your views on the following criteria.
                            </p>
                        </div>
                
                <div class="intro">
                    Dear our valued client,<br><br>
                    <strong>INHOME GROUP SDN BHD</strong> strives to provide our client with the highest possible level of 
                    services and projects. In order for us to continuously improve our services, could you spare some 
                    time and participate in our Satisfaction Survey by giving us your views on the following:
                </div>
                
                <div style="margin-bottom: 15px; font-size: 12px;">
                    Please tick (√) one
                </div>
                
                <table class="criteria-table">
                    <thead>
                        <tr>
                            <th rowspan="2" style="width: 80px;">Criteria</th>
                            <th>Excellent</th>
                            <th>Good</th>
                            <th>Average</th>
                            <th>Poor</th>
                            <th>Unacceptable</th>
                        </tr>
                        <tr>
                            <th class="rating-cell">5</th>
                            <th class="rating-cell">4</th>
                            <th class="rating-cell">3</th>
                            <th class="rating-cell">2</th>
                            <th class="rating-cell">1</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="criteria-name">1. Pricing</td>
                            <td class="rating-cell">${
                                savedSurvey.pricing === "5"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.pricing === "4"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.pricing === "3"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.pricing === "2"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.pricing === "1"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                        </tr>
                        <tr>
                            <td class="criteria-name">2. Project Completion</td>
                            <td class="rating-cell">${
                                savedSurvey.projectCompletion === "5"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.projectCompletion === "4"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.projectCompletion === "3"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.projectCompletion === "2"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.projectCompletion === "1"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                        </tr>
                        <tr>
                            <td class="criteria-name">3. Quality of work</td>
                            <td class="rating-cell">${
                                savedSurvey.qualityOfWork === "5"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.qualityOfWork === "4"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.qualityOfWork === "3"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.qualityOfWork === "2"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.qualityOfWork === "1"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                        </tr>
                        <tr>
                            <td class="criteria-name">4. Communication</td>
                            <td class="rating-cell">${
                                savedSurvey.communication === "5"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.communication === "4"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.communication === "3"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.communication === "2"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.communication === "1"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                        </tr>
                        <tr>
                            <td class="criteria-name">5. Maintenance</td>
                            <td class="rating-cell">${
                                savedSurvey.maintenance === "5"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.maintenance === "4"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.maintenance === "3"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.maintenance === "2"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                            <td class="rating-cell">${
                                savedSurvey.maintenance === "1"
                                    ? '<span class="rating-mark">√</span>'
                                    : ""
                            }</td>
                        </tr>
                    </tbody>
                </table>
                
                ${
                    savedSurvey.starRating ? `
                <div class="form-field" style="margin: 24px 0; padding: 20px; background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border: 2px solid #fbbf24; border-radius: 8px;">
                    <div style="margin-bottom: 12px; font-weight: 600; color: #92400e; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px;">
                        Overall Rating
                    </div>
                    <div style="display: flex; align-items: center; gap: 8px;">
                        ${Array.from({ length: 5 }, (_, i) => {
                            const starNum = i + 1;
                            const isFilled = starNum <= parseInt(savedSurvey.starRating);
                            return `<span style="font-size: 24px; color: ${isFilled ? '#f59e0b' : '#d1d5db'}; ${isFilled ? 'text-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);' : ''}">★</span>`;
                        }).join('')}
                        <span style="margin-left: 12px; font-size: 18px; font-weight: 700; color: #92400e;">
                            ${savedSurvey.starRating} / 5
                        </span>
                        ${
                            parseInt(savedSurvey.starRating) === 5 ? '<span style="margin-left: 8px; color: #059669; font-weight: 600;">Excellent!</span>' :
                            parseInt(savedSurvey.starRating) === 4 ? '<span style="margin-left: 8px; color: #059669; font-weight: 600;">Very Good!</span>' :
                            parseInt(savedSurvey.starRating) === 3 ? '<span style="margin-left: 8px; color: #d97706; font-weight: 600;">Good</span>' :
                            parseInt(savedSurvey.starRating) === 2 ? '<span style="margin-left: 8px; color: #dc2626; font-weight: 600;">Fair</span>' :
                            parseInt(savedSurvey.starRating) === 1 ? '<span style="margin-left: 8px; color: #dc2626; font-weight: 600;">Poor</span>' : ''
                        }
                    </div>
                </div>
                    ` : ''
                }
                
                <div class="comments-section">
                    <div style="margin-bottom: 10px; font-weight: bold;">
                        Please tell us your comments or suggestion in order to improve our service to you:
                    </div>
                    <div style="border: 1px solid black; min-height: 60px; padding: 10px; background-color: #f9f9f9;">
                        ${savedSurvey.comments || ''}
                    </div>
                </div>
                
                <div class="form-field">
                    Confirmation Order no: <span class="underline">${
                        orderData?.coNumber || orderData?.invoiceId || 'N/A'
                    }</span>
                </div>
                
                <div class="form-field">
                    Customer Name: <span class="underline">${
                        orderData?.userId?.name || 'N/A'
                    }</span>
                </div>
                
                <div class="form-field">
                    Address: <span class="underline">${
                        formattedAddress || 'N/A'
                    }</span>
                </div>
                
                <div class="form-field">
                    Date: <span class="underline">${savedSurvey.surveyDate ? moment(savedSurvey.surveyDate).format("DD MMM YYYY") : 'N/A'}</span>
                </div>
                
                <div class="form-field">
                    Time: <span class="underline">${savedSurvey.time || 'N/A'}</span>
                </div>
                
                <div class="form-field">
                    IC Number: <span class="underline">${savedSurvey.ic || orderData?.userId?.ic || 'N/A'}</span>
                </div>
                
                <div class="form-field">
                    <div style="margin-bottom: 10px; font-weight: bold;">Signature:</div>
                    <div style="border: 1px solid black; height: 100px; display: flex; align-items: center; justify-content: center; background-color: #f9f9f9;">
                        ${
                            savedSurvey.signature
                                ? `<img src="${savedSurvey.signature}" style="max-height: 90px; max-width: 300px;" alt="Signature" />`
                                : '<span style="color: #666;">No signature provided</span>'
                        }
                    </div>
                </div>
                
                <div class="no-print" style="margin-top: 30px; text-align: center;">
                    <button onclick="window.print()" style="padding: 10px 20px; font-size: 14px; background-color: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">
                        Print Survey
                    </button>
                    <button onclick="window.close()" style="padding: 10px 20px; font-size: 14px; background-color: #6c757d; color: white; border: none; border-radius: 5px; cursor: pointer; margin-left: 10px;">
                        Close
                    </button>
                </div>
            </body>
            </html>
        `;

        printWindow.document.write(htmlContent);
        printWindow.document.close();
    };

    // Handle confirm completed
    const handleConfirmCompleted = async (selectedCommenceDate) => {
        if (!currentUser || !orderData) {
            alert("Please login and ensure order data is available");
            return;
        }

        setIsConfirmingCompleted(true);
        try {
            let completionFromApproval = null;
            if (orderData.createdAt) {
                const createdDate = new Date(orderData.createdAt);
                const commence = new Date(selectedCommenceDate);
                createdDate.setHours(0, 0, 0, 0);
                commence.setHours(0, 0, 0, 0);
                const diffTime = commence - createdDate;
                completionFromApproval = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
            }

            const response = await userRequest.put(`/orders/confirmCompleted/${orderData._id}`, {
                commenceDate: selectedCommenceDate,
                status: "completed",
                completionFromApproval
            });

            if (response.data) {
                setOrderData(response.data);
                alert("Order marked as completed successfully!");
                // Refresh order data
                fetchOrderData();
            } else {
                alert("Failed to mark order as completed");
            }
        } catch (error) {
            console.error("Error confirming completion:", error);
            alert("Failed to mark order as completed. Please try again.");
        } finally {
            setIsConfirmingCompleted(false);
        }
    };

    // Blueprint handling functions
    const handleDeleteBlueprint = async (data) => {
        setDeleteBlueprintData(data);
        setDeleteBlueprintModalState(true);
    };

    const confirmDeleteBlueprint = async () => {
        try {
            const res = await userRequest.post(
                `/orders/deleteBlueprint`,
                deleteBlueprintData
            );
            if (res.data) {
                // Update orderData to remove the deleted blueprint
                setOrderData((prev) => ({
                    ...prev,
                    blueprint: prev.blueprint.filter(
                        (blueprint) => blueprint._id !== deleteBlueprintData.blueprintId
                    )
                }));
                alert("Blueprint deleted successfully");
                setDeleteBlueprintModalState(false);
                setDeleteBlueprintData(null);
            } else {
                alert("Failed to delete blueprint");
            }
        } catch (error) {
            alert("Failed to delete blueprint");
        }
    };

    const resetAddBlueprintModal = () => {
        setAddBlueprintModalState(false);
        setIsUploadingBlueprint(false);
    };

    const handleBlueprintUpload = async (file, blueprintName, itemName = "") => {
        if (isUploadingBlueprint) {
            return;
        }

        setIsUploadingBlueprint(true);

        try {
            let newImage = undefined;

            if (file) {
                const imageresult = await generateSignature();
                const imageFormData = new FormData();

                imageFormData.append("file", file);
                imageFormData.append(
                    "publicKey",
                    "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                );
                imageFormData.append("signature", imageresult.data.signature);
                imageFormData.append("token", imageresult.data.token);
                imageFormData.append("expire", imageresult.data.expire);
                imageFormData.append("fileName", file.name);
                imageFormData.append("folder", "IHGroup");

                try {
                    const imageKitRequest = await axios.post(
                        "https://upload.imagekit.io/api/v1/files/upload",
                        imageFormData
                    );
                    newImage = imageKitRequest.data.url;
                } catch (error) {
                    throw new Error("Image upload failed");
                }
            }

            const res = await userRequest.post("/orders/addBlueprint", {
                orderId: orderData._id,
                name: blueprintName,
                url: newImage,
                user: currentUser._id,
                itemName: itemName,
            });

            if (res.data) {
                // Update orderData with the new blueprint data from the response
                setOrderData((prev) => {
                    const updated = {
                        ...prev,
                        blueprint: res.data.blueprint || [],
                        uploadedDraftDate: res.data.uploadedDraftDate || prev.uploadedDraftDate,
                        status: res.data.status || prev.status
                    };
                    return updated;
                });
                
                // Return the newly added blueprint (last one in the array)
                const newBlueprint = res.data.blueprint[res.data.blueprint.length - 1];
                return newBlueprint;
            } else {
                throw new Error("Upload failed - no data in response");
            }
        } catch (err) {
            console.error("Error uploading blueprint:", err);

            // Check if it's an HTTP error with response
            if (err.response) {
                console.error("HTTP Error Status:", err.response.status);
                console.error("HTTP Error Data:", err.response.data);
                console.error("HTTP Error Headers:", err.response.headers);

                throw new Error(
                    `Failed to upload blueprint: ${err.response.status} - ${
                        err.response.data?.message ||
                        err.response.data ||
                        "Server error"
                    }`
                );
            } else if (err.request) {
                console.error(
                    "Network Error - Request made but no response:",
                    err.request
                );
                throw new Error(
                    "Failed to upload blueprint: Network error - no response from server"
                );
            } else {
                console.error("Request Setup Error:", err.message);
                throw new Error(
                    "Failed to upload blueprint: " +
                        (err.message || "Unknown error")
                );
            }
        } finally {
            setIsUploadingBlueprint(false);
        }
    };

    const handleSubmitDraft = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setSubmitDraftModalState(true);
    };

    const confirmSubmitDraft = async () => {
        try {
            const res = await userRequest.put(
                `/orders/updateStatus/${orderData._id}`,
                {
                    status: "uploadedDraft"
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "uploadedDraft"
                }));
                alert("Draft submitted successfully! Order status updated to 'uploadedDraft'.");
                setSubmitDraftModalState(false);
            } else {
                alert("Failed to submit draft - no response data");
            }
        } catch (error) {
            console.error("Error submitting draft:", error);
            alert("Failed to submit draft. Please try again.");
        }
    };

    const handleToggleBlueprintCheck = (blueprintId) => {
        setCheckedBlueprints(prev => ({
            ...prev,
            [blueprintId]: !prev[blueprintId]
        }));
    };

    const areAllBlueprintsChecked = () => {
        if (!orderData?.blueprint || orderData.blueprint.length === 0) {
            return false;
        }
        return orderData.blueprint.every(blueprint => checkedBlueprints[blueprint._id]);
    };

    const handleBlueprintFieldChange = (blueprintId, field, value) => {
        setOrderData((prev) => {
            if (!prev.blueprint) return prev;
            
            const updatedBlueprints = prev.blueprint.map((bp) => {
                if (bp._id === blueprintId) {
                    return {
                        ...bp,
                        [field]: value
                    };
                }
                return bp;
            });
            
            return {
                ...prev,
                blueprint: updatedBlueprints
            };
        });
    };

    const handleApproveDraft = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Check if all blueprints are checked
        if (!areAllBlueprintsChecked()) {
            alert("Please check all blueprints before approving the draft.");
            return;
        }

        // Automatically set to today's date
        const today = new Date().toISOString();

        // Prepare blueprint updates with color, size, and materials
        const blueprintUpdates = orderData.blueprint.map((bp) => ({
            blueprintId: bp._id,
            color: bp.color || '',
            size: bp.size || '',
            materials: bp.materials || ''
        }));

        try {
            const res = await userRequest.put(
                `/orders/draftApproved/${orderData._id}`,
                {
                    commenceDate: today,
                    blueprintApprovalBy: currentUser._id,
                    blueprints: blueprintUpdates
                }
            );

            if (res.data) {
                // Update orderData with the new status and approval details
                setOrderData((prev) => ({
                    ...prev,
                    status: "pendingSalesmanDraft",
                    blueprintApprovalDate: today,
                    blueprintApprovalBy: currentUser._id
                }));
                alert("Draft approved successfully! Order status updated to 'pendingSalesmanDraft'.");
                setApproveDraftModalState(false);
            } else {
                alert("Failed to approve draft - no response data");
            }
        } catch (error) {
            console.error("Error approving draft:", error);
            alert("Failed to approve draft. Please try again.");
        }
    };

    const handleRejectDraft = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        try {
            const res = await userRequest.put(
                `/orders/rejectDraft/${orderData._id}`,
                {
                    status: "pending",
                    draftRejectedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "pending",
                    draftRejectedBy: currentUser._id
                }));
                alert("Draft rejected successfully! Order status updated to 'pending'.");
                setRejectDraftModalState(false);
            } else {
                alert("Failed to reject draft - no response data");
            }
        } catch (error) {
            console.error("Error rejecting draft:", error);
            alert("Failed to reject draft. Please try again.");
        }
    };

    const clearCustomerSignature = () => {
        if (customerSignatureRef) {
            const ctx = customerSignatureRef.getContext("2d");
            ctx.clearRect(0, 0, customerSignatureRef.width, customerSignatureRef.height);
        }
    };

    const handleCustomerApprove = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Check if all blueprints are checked
        if (!areAllBlueprintsChecked()) {
            alert("Please check all blueprints before approving.");
            return;
        }

        // Check if signature is provided
        if (!customerSignatureRef) {
            alert("Please provide a signature before approving");
            return;
        }

        const canvas = customerSignatureRef;
        const ctx = canvas.getContext("2d");
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const isBlank = !imageData.data.some(channel => channel !== 0);

        if (isBlank) {
            alert("Please provide a signature before approving");
            return;
        }

        // Capture signature as base64
        const signatureDataUrl = canvas.toDataURL("image/png");

        // Automatically set to today's date
        const today = new Date().toISOString();

        try {
            const res = await userRequest.put(
                `/orders/customerApproved/${orderData._id}`,
                {
                    commenceDate: today,
                    customerApprovedBy: currentUser._id,
                    customerApprovalSignature: signatureDataUrl
                }
            );

            if (res.data) {
                // Update orderData with the new status and approval details
                setOrderData((prev) => ({
                    ...prev,
                    status: "draftApproved",
                    customerApprovedDate: today,
                    customerApprovedBy: currentUser._id,
                    customerApprovalSignature: signatureDataUrl
                }));
                alert("Customer approval successful! Order status updated to 'draftApproved'.");
                setCustomerApproveModalState(false);
                clearCustomerSignature();
            } else {
                alert("Failed to approve customer - no response data");
            }
        } catch (error) {
            console.error("Error approving customer:", error);
            alert("Failed to approve customer. Please try again.");
        }
    };

    const handleSalesmanApprove = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Check if all blueprints are checked
        if (!areAllBlueprintsChecked()) {
            alert("Please check all blueprints before approving.");
            return;
        }

        // Automatically set to today's date
        const today = new Date().toISOString();

        try {
            const res = await userRequest.put(
                `/orders/salesmanApproved/${orderData._id}`,
                {
                    commenceDate: today,
                    salesmanApprovedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status and approval details
                setOrderData((prev) => ({
                    ...prev,
                    status: "pendingCustomerDraft",
                    salesmanApprovedDate: today,
                    salesmanApprovedBy: currentUser._id
                }));
                alert("Salesman approval successful! Order status updated to 'pendingCustomerDraft'.");
                setSalesmanApproveModalState(false);
            } else {
                alert("Failed to approve salesman - no response data");
            }
        } catch (error) {
            console.error("Error approving salesman:", error);
            alert("Failed to approve salesman. Please try again.");
        }
    };

    const handleSalesmanReject = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        try {
            const res = await userRequest.put(
                `/orders/salesmanReject/${orderData._id}`,
                {
                    salesmanRejectedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status and rejection details
                setOrderData((prev) => ({
                    ...prev,
                    status: "uploadedDraft",
                    salesmanRejectedDate: new Date().toISOString(),
                    salesmanRejectedBy: currentUser._id
                }));
                alert("Salesman rejection successful! Order status updated to 'uploadedDraft'.");
                setSalesmanRejectModalState(false);
            } else {
                alert("Failed to reject salesman - no response data");
            }
        } catch (error) {
            console.error("Error rejecting salesman:", error);
            alert("Failed to reject salesman. Please try again.");
        }
    };

    const handleCustomerReject = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        try {
            const res = await userRequest.put(
                `/orders/customerReject/${orderData._id}`,
                {
                    customerRejectedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "uploadedDraft",
                    customerRejectedBy: currentUser._id
                }));
                alert("Customer rejected draft successfully! Order status updated to 'uploadedDraft'.");
                setCustomerRejectModalState(false);
            } else {
                alert("Failed to reject draft - no response data");
            }
        } catch (error) {
            console.error("Error rejecting customer draft:", error);
            alert("Failed to reject customer draft. Please try again.");
        }
    };

    const handleSubmitPurchaseOrder = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Always update purchase order first so latest materials are saved
        const updated = await handlePosCreatePurchaseOrder(true);
        if (!updated) {
            // If updating purchase order failed or was cancelled, do not proceed
            return;
        }

        // Calculate total materials cost from current materialsCart (just saved above)
        const orderTotal = orderData.amount || 0;
        const deposit = orderData.deposit || 0;
        const minRequiredDeposit = orderTotal * 0.5;

        // Calculate total materials costing from materialsCart
        const totalMaterialCost = Array.isArray(materialsCart)
            ? materialsCart.reduce((sum, mat) => sum + ((Number(mat.price || mat.activeColor?.price || 0)) * (mat.amount || 0)), 0)
            : 0;
        const materialCostPercentage = orderTotal > 0 ? ((totalMaterialCost / orderTotal) * 100) : 0;

        // Check if deposit is at least 50% of order total.
        // Skip this restriction when order has approved Skip50 flag.
        if (!orderData.skip50Percent && deposit < minRequiredDeposit) {
            const depositPercentage = orderTotal > 0 ? ((deposit / orderTotal) * 100).toFixed(2) : 0;
            alert(
                `Cannot submit purchase order!\n\n` +
                `Deposit paid (RM ${deposit.toFixed(2)}) is less than 50% of order total (RM ${orderTotal.toFixed(2)}).\n\n` +
                `Current deposit percentage: ${depositPercentage}%\n` +
                `Minimum required: 50%\n\n` +
                `Please ensure the deposit is at least RM ${(minRequiredDeposit).toFixed(2)} before submitting.`
            );
            return;
        }

        // Check if materials costing exceeds 40% of order amount
        if (materialCostPercentage > 30) {
            alert(
                `Warning: Purchase Order material cost is ${(materialCostPercentage).toFixed(2)}% of total order value!\n` +
                `Material costing (RM ${totalMaterialCost.toFixed(2)}) exceeds 40% of order total (RM ${orderTotal.toFixed(2)}).\n\n` +
                `Please double-check the bill of materials before proceeding.`
            );
            // Still allow, just warn
        }

        setSubmitPurchaseOrderModalState(true);
    };

    const confirmSubmitPurchaseOrder = async () => {
        try {
            const arrivedDate = new Date().toISOString();
            // Save arrived date
            await userRequest.put(
                `/orders/update/${orderData._id}`,
                {
                    purchaseOrderArrivedDate: arrivedDate
                }
            );
            // Complete the purchase
            const res = await userRequest.put(
                `/orders/completePurchase/${orderData._id}`,
                {
                    purchaseOrderApprovedBy: currentUser._id
                }
            );

            if (res.data) {
                setOrderData((prev) => ({
                    ...prev,
                    purchaseOrderArrivedDate: arrivedDate,
                    status: "purchaseApproved",
                    purchaseOrderApprovedBy: currentUser._id,
                    purchaseOrderApprovedDate: new Date().toISOString()
                }));
                alert("Purchase order submitted successfully! Order status updated to 'purchase approved'.");
                setSubmitPurchaseOrderModalState(false);
            } else {
                alert("Failed to submit purchase order - no response data");
            }
        } catch (error) {
            console.error("Error submitting purchase order:", error);
            alert("Failed to submit purchase order. Please try again.");
        }
    };

    const handleApprovePurchaseOrder = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setApprovePurchaseOrderModalState(true);
    };

    const handleRejectPurchaseOrder = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setRejectPurchaseOrderModalState(true);
    };

    const confirmRejectPurchaseOrder = async () => {
        try {
            const res = await userRequest.put(
                `/orders/rejectPurchaseOrder/${orderData._id}`,
                {
                    purchaseOrderRejectedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "pending",
                    purchaseOrderRejectedBy: currentUser._id
                }));
                alert("Purchase order rejected successfully! Order status updated to 'pending'.");
                setRejectPurchaseOrderModalState(false);
            } else {
                alert("Failed to reject purchase order - no response data");
            }
        } catch (error) {
            console.error("Error rejecting purchase order:", error);
            alert("Failed to reject purchase order. Please try again.");
        }
    };

    const handleCompletePurchase = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setCompletePurchaseModalState(true);
    };

    const confirmCompletePurchase = async () => {
        try {
            const res = await userRequest.put(
                `/orders/completePurchase/${orderData._id}`,
                {
                    purchaseOrderApprovedBy: currentUser._id
                }
            );

            if (res.data) {
                setOrderData((prev) => ({
                    ...prev,
                    status: "purchaseApproved",
                    purchaseOrderApprovedBy: currentUser._id,
                    purchaseOrderApprovedDate: new Date().toISOString()
                }));
                alert("Purchase completed successfully! Order status updated to 'purchaseApproved'.");
                setCompletePurchaseModalState(false);
            } else {
                alert("Failed to complete purchase - no response data");
            }
        } catch (error) {
            console.error("Error completing purchase:", error);
            alert("Failed to complete purchase. Please try again.");
        }
    };

    const handleConfirmPOArrived = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setConfirmPOArrivedModalState(true);
    };

    const confirmPOArrived = async () => {
        try {
            const arrivedDate = new Date().toISOString();
            // Save arrived date
            await userRequest.put(
                `/orders/update/${orderData._id}`,
                {
                    purchaseOrderArrivedDate: arrivedDate
                }
            );
            // Complete the purchase
            const res = await userRequest.put(
                `/orders/completePurchase/${orderData._id}`,
                {
                    purchaseOrderApprovedBy: currentUser._id
                }
            );

            if (res.data) {
                setOrderData((prev) => ({
                    ...prev,
                    purchaseOrderArrivedDate: arrivedDate,
                    status: "purchaseApproved",
                    purchaseOrderApprovedBy: currentUser._id,
                    purchaseOrderApprovedDate: new Date().toISOString()
                }));
                alert("Purchase order arrival confirmed and purchasing completed!");
                setConfirmPOArrivedModalState(false);
            } else {
                alert("Failed to confirm PO arrival - no response data");
            }
        } catch (error) {
            console.error("Error confirming PO arrival:", error);
            alert("Failed to confirm PO arrival. Please try again.");
        }
    };

    const handleSubmitProduction = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Always update production usage first so latest adjustments are saved
        const updated = await handlePosCreateProductionUsage(true);
        if (!updated) {
            // If updating production usage failed or was cancelled, do not proceed
            return;
        }

        setSubmitProductionModalState(true);
    };

    const confirmSubmitProduction = async () => {
        try {
            const res = await userRequest.put(
                `/orders/updateStatus/${orderData._id}`,
                {
                    status: "production"
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "production"
                }));
                alert("Production submitted successfully! Order status updated to 'production'.");
                setSubmitProductionModalState(false);
            } else {
                alert("Failed to submit production - no response data");
            }
        } catch (error) {
            console.error("Error submitting production:", error);
            alert("Failed to submit production. Please try again.");
        }
    };

    const handleCompleteProduction = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setCompleteProductionModalState(true);
    };

    const confirmCompleteProduction = async () => {
        try {
            const completedDate = new Date().toISOString();
            const res = await userRequest.put(
                `/orders/update/${orderData._id}`,
                {
                    productionCompletedDate: completedDate
                }
            );

            if (res.data) {
                setOrderData((prev) => ({
                    ...prev,
                    productionCompletedDate: completedDate,
                }));
                alert("Production marked as complete! Please confirm when production is fully completed.");
                setCompleteProductionModalState(false);
            } else {
                alert("Failed to complete production - no response data");
            }
        } catch (error) {
            console.error("Error completing production:", error);
            alert("Failed to complete production. Please try again.");
        }
    };

    const handleConfirmProductionCompleted = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        setConfirmProductionCompletedModalState(true);
    };

    const confirmProductionCompleted = async () => {
        try {
            const res = await userRequest.put(
                `/orders/completeProduction/${orderData._id}`,
                {
                    productionApprovalBy: currentUser._id
                }
            );

            if (res.data) {
                setOrderData((prev) => ({
                    ...prev,
                    status: "productionApproved",
                    productionApprovalBy: currentUser._id,
                    productionApprovalDate: new Date().toISOString()
                }));
                alert("Production completion confirmed! Order status updated to 'productionApproved'.");
                setConfirmProductionCompletedModalState(false);
            } else {
                alert("Failed to confirm production completion - no response data");
            }
        } catch (error) {
            console.error("Error confirming production completion:", error);
            alert("Failed to confirm production completion. Please try again.");
        }
    };

    const handleApproveProduction = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Automatically set to today's date
        const today = new Date().toISOString();

        try {
            const res = await userRequest.put(
                `/orders/completeProduction/${orderData._id}`,
                {
                    commenceDate: today,
                    productionApprovalBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status and approval details
                setOrderData((prev) => ({
                    ...prev,
                    status: "productionApproved",
                    productionApprovalDate: today,
                    productionApprovalBy: currentUser._id
                }));
                alert("Production approved successfully! Order status updated to 'productionApproved'.");
                setApproveProductionModalState(false);
            } else {
                alert("Failed to approve production - no response data");
            }
        } catch (error) {
            console.error("Error approving production:", error);
            alert("Failed to approve production. Please try again.");
        }
    };

    const handleRejectProduction = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        try {
            const res = await userRequest.put(
                `/orders/rejectProduction/${orderData._id}`,
                {
                    productionRejectedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status
                setOrderData((prev) => ({
                    ...prev,
                    status: "purchasing",
                    productionRejectedBy: currentUser._id
                }));
                alert("Production rejected successfully! Order status updated to 'purchasing'.");
                setRejectProductionModalState(false);
            } else {
                alert("Failed to reject production - no response data");
            }
        } catch (error) {
            console.error("Error rejecting production:", error);
            alert("Failed to reject production. Please try again.");
        }
    };

    const handleApproveInstallation = async () => {
        if (!orderData || !orderData._id) {
            alert("Order data not available");
            return;
        }

        // Automatically set to today's date
        const today = new Date().toISOString();

        try {
            const res = await userRequest.put(
                `/orders/completeInstall/${orderData._id}`,
                {
                    commenceDate: today,
                    installApprovedBy: currentUser._id
                }
            );

            if (res.data) {
                // Update orderData with the new status and approval details
                setOrderData((prev) => ({
                    ...prev,
                    status: "installApproved",
                    installApprovedDate: today,
                    installApprovedBy: currentUser._id
                }));
                alert("Installation approved successfully! Order status updated to 'installApproved'.");
                setApproveInstallationModalState(false);
            } else {
                alert("Failed to approve installation - no response data");
            }
        } catch (error) {
            console.error("Error approving installation:", error);
            alert("Failed to approve installation. Please try again.");
        }
    };

    const handleQuantity = (
        product,
        quantity,
        amount,
        myAmount,
        activeColor,
        cartIndex
    ) => {
        dispatch(
            addQuantityIcon({
                ...product,
                quantity,
                amount,
                myAmount,
                activeColor,
                cartIndex,
            })
        );
    };

    const handlePosCreateOrder = async () => {
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        const chargeableExpenses = Object.values(expensesData || {}).reduce(
            (sum, value) => sum + (parseFloat(value) || 0),
            0,
        );
        if (total + chargeableExpenses - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        const addressLineError = validateOrderAddressLines(inputs);
        if (addressLineError) {
            alert(addressLineError);
            return;
        }

        const predata = orderData;


        if (currentUser) {
            try {
                const updateData = {
                    products: cart.map((item) => {
                        const colorItemCode =
                            item.color?.itemCode || item.activeColor?.itemCode;
                        const isOthersLine =
                            colorItemCode === "OTHERS" ||
                            colorItemCode === "others";
                        
                        // Helper to check if a value is a valid custom code (not empty, not "Others")
                        const isValidCustomCode = (val) => val && typeof val === 'string' && 
                            val.trim() && val.trim().toLowerCase() !== 'others';
                        
                        // For Others items, find the first valid custom code from name or type
                        const getOthersCodeValue = () => {
                            if (isValidCustomCode(item.color?.name)) return item.color.name.trim();
                            if (isValidCustomCode(item.activeColor?.name)) return item.activeColor.name.trim();
                            if (isValidCustomCode(item.color?.type)) return item.color.type.trim();
                            if (isValidCustomCode(item.activeColor?.type)) return item.activeColor.type.trim();
                            // Fallback: return whatever we have, even if it's "Others"
                            return item.color?.name || item.activeColor?.name || item.color?.type || item.activeColor?.type || item.title;
                        };
                        
                        const ipohAwning = resolveIpohAwningOrderFields(
                            item.color || item.activeColor
                        );
                        const codeValue = ipohAwning?.code
                            ? ipohAwning.code
                            : isOthersLine
                            ? getOthersCodeValue()
                            : item.color && item.color.itemCode
                              ? item.color.itemCode
                              : item.activeColor?.itemCode
                                ? item.activeColor.itemCode
                                : item.color.name;
                        return {
                        productId: typeof item._id === 'object' ? item._id._id : item._id,
                        quantity: item.amount,
                        code: codeValue,
                        title: ipohAwning
                            ? ipohAwning.title
                            : String(
                                item.color?.customTitle ||
                                    item.activeColor?.customTitle ||
                                    ""
                            ).trim() || undefined,
                        img: item.img,
                        price: item.price,
                        amount: item.amount,
                        type: ipohAwning ? undefined : item.type,
                        itemCode: ipohAwning
                            ? undefined
                            : item.color?.itemCode || item.activeColor?.itemCode,
                        typeDescription: ipohAwning
                            ? undefined
                            : (item.title === "T-Light" || item.title === "Stainless Steel Gutter" || item.title === "Flashing") 
                            ? item.title 
                            : (item.color?.type || item.activeColor?.type || item.title),
                        frameColor: item.color?.frameColor || item.activeColor?.frameColor,
                        // Record field: pass when it exists (preserves "normal" or "late")
                        ...(item.record && { record: item.record }),
                        // Track who created this product entry and when
                        createdBy: item.createdBy || currentUser._id,
                        createdAt: item.createdAt || new Date().toISOString(),
                        // Awning category items array
                        items: ipohAwning
                            ? ipohAwning.items
                            : item.color?.items || item.activeColor?.items || [],
                        // For Steel Hollow products, size is stored in steelhollowSize, not size
                        size: item.color?.sizeWidth && item.color?.sizeLength && !item.color?.steelhollowItemCode
                            ? (item.color?.sizeHeight 
                                ? `${item.color.sizeWidth}' (w) x ${item.color.sizeLength}' (l) x ${item.color.sizeHeight}' (h)` 
                                : `${item.color.sizeWidth}' (w) x ${item.color.sizeLength}' (l)`)
                            : item.activeColor?.sizeWidth && item.activeColor?.sizeLength && !item.activeColor?.steelhollowItemCode
                            ? (item.activeColor?.sizeHeight 
                                ? `${item.activeColor.sizeWidth}' (w) x ${item.activeColor.sizeLength}' (l) x ${item.activeColor.sizeHeight}' (h)` 
                                : `${item.activeColor.sizeWidth}' (w) x ${item.activeColor.sizeLength}' (l)`)
                            : undefined,
                        pvcGutterItemCode: item.color?.pvcGutterItemCode || item.activeColor?.pvcGutterItemCode,
                        pvcGutterType: item.color?.pvcGutterType || item.activeColor?.pvcGutterType,
                        giGutterSize: item.color?.giGutterSize || item.activeColor?.giGutterSize,
                        stainlessSteelGutterSize: item.color?.stainlessSteelGutterSize || item.activeColor?.stainlessSteelGutterSize,
                        ft: item.color?.ft || item.activeColor?.ft || item.color?.tLightSize || item.activeColor?.tLightSize, // Support both old tLightSize and new ft field
                        aluminumGutterType: item.color?.aluminumGutterType || item.activeColor?.aluminumGutterType,
                        aluminumGutterSize: item.color?.aluminumGutterSizeWidth && item.color?.aluminumGutterSizeLength
                            ? `${item.color.aluminumGutterSizeWidth}' (w) x ${item.color.aluminumGutterSizeLength}' (l)`
                            : item.activeColor?.aluminumGutterSizeWidth && item.activeColor?.aluminumGutterSizeLength
                            ? `${item.activeColor.aluminumGutterSizeWidth}' (w) x ${item.activeColor.aluminumGutterSizeLength}' (l)`
                            : undefined,
                        flashingItemCode: item.color?.flashingItemCode || item.activeColor?.flashingItemCode,
                        flashingType: item.color?.flashingType || item.activeColor?.flashingType,
                        steelhollowItemCode: item.color?.steelhollowItemCode || item.activeColor?.steelhollowItemCode,
                        steelhollowType: item.color?.steelhollowType || item.activeColor?.steelhollowType,
                        steelhollowSize: (item.color?.sizeWidth && item.color?.sizeLength && item.color?.sizeHeight && (item.color?.itemCode || item.color?.steelhollowItemCode))
                            ? `${item.color.sizeWidth}' (w) x ${item.color.sizeLength}' (l) x ${item.color.sizeHeight}' (h)`
                            : (item.activeColor?.sizeWidth && item.activeColor?.sizeLength && item.activeColor?.sizeHeight && (item.activeColor?.itemCode || item.activeColor?.steelhollowItemCode))
                            ? `${item.activeColor.sizeWidth}' (w) x ${item.activeColor.sizeLength}' (l) x ${item.activeColor.sizeHeight}' (h)`
                            : undefined,
                        // Awning fields
                        acpItemCode: item.color?.acpItemCode || item.activeColor?.acpItemCode,
                        acpType: item.color?.acpType || item.activeColor?.acpType,
                        acpFrameColor: item.color?.acpFrameColor || item.activeColor?.acpFrameColor,
                        acpSize: item.color?.acpSizeWidth && item.color?.acpSizeLength
                            ? `${item.color.acpSizeWidth}' (w) x ${item.color.acpSizeLength}' (l)`
                            : item.activeColor?.acpSizeWidth && item.activeColor?.acpSizeLength
                            ? `${item.activeColor.acpSizeWidth}' (w) x ${item.activeColor.acpSizeLength}' (l)`
                            : undefined,
                        glassItemCode: item.color?.glassItemCode || item.activeColor?.glassItemCode,
                        glassType: item.color?.glassType || item.activeColor?.glassType,
                        glassSize: item.color?.glassSizeWidth && item.color?.glassSizeLength
                            ? `${item.color.glassSizeWidth}' (w) x ${item.color.glassSizeLength}' (l)`
                            : item.activeColor?.glassSizeWidth && item.activeColor?.glassSizeLength
                            ? `${item.activeColor.glassSizeWidth}' (w) x ${item.activeColor.glassSizeLength}' (l)`
                            : undefined,
                        metalDeckItemCode: item.color?.metalDeckItemCode || item.activeColor?.metalDeckItemCode,
                        metalDeckType: item.color?.metalDeckType || item.activeColor?.metalDeckType,
                        metalDeckSize: item.color?.metalDeckSizeWidth && item.color?.metalDeckSizeLength
                            ? `${item.color.metalDeckSizeWidth}' (w) x ${item.color.metalDeckSizeLength}' (l)`
                            : item.activeColor?.metalDeckSizeWidth && item.activeColor?.metalDeckSizeLength
                            ? `${item.activeColor.metalDeckSizeWidth}' (w) x ${item.activeColor.metalDeckSizeLength}' (l)`
                            : undefined,
                        polycarbonateItemCode: item.color?.polycarbonateItemCode || item.activeColor?.polycarbonateItemCode,
                        polycarbonateType: item.color?.polycarbonateType || item.activeColor?.polycarbonateType,
                        polycarbonateSize: item.color?.polycarbonateSizeWidth && item.color?.polycarbonateSizeLength
                            ? `${item.color.polycarbonateSizeWidth}' (w) x ${item.color.polycarbonateSizeLength}' (l)`
                            : item.activeColor?.polycarbonateSizeWidth && item.activeColor?.polycarbonateSizeLength
                            ? `${item.activeColor.polycarbonateSizeWidth}' (w) x ${item.activeColor.polycarbonateSizeLength}' (l)`
                            : undefined,
                        model: item.model,
                        fabricColor: item.color?.fabricColor || item.activeColor?.fabricColor,
                        sidePanelColor: item.color?.sidePanelColor || item.activeColor?.sidePanelColor,
                        fabric: item.color?.fabric || item.activeColor?.fabric,
                        transparency: item.color?.transparency || item.activeColor?.transparency,
                        };
                    }),
                    amount: total,
                    discount: inputs.discount,
                    userId: inputs.vehicle,
                    referral: inputs.referral,
                    coNumber: inputs.coNumber,
                    paymentType: inputs.paymentType || undefined,
                    estimatedInstallationDays: inputs.estimatedInstallationDays,
                    firstPayment: inputs.firstPayment,
                    ...Object.fromEntries(
                        ORDER_FORM_PAYMENTS.map((field) => [field.name, inputs[field.name]])
                    ),
                    cashier: orderInfo.cashier
                        ? orderInfo.cashier._id
                        : inputs.cashier,
                    ...(isIpohAccount
                        ? { secondSalesperson: orderInfo.secondSalesperson || null }
                        : {}),
                    lineOne: inputs.lineOne,
                    lineTwo: inputs.lineTwo,
                    zip: inputs.zip,
                    city: inputs.city,
                    country: inputs.country,
                    billingLineOne:
                        inputs.billingSameAsAddress === true
                            ? inputs.lineOne
                            : inputs.billingLineOne,
                    billingLineTwo:
                        inputs.billingSameAsAddress === true
                            ? inputs.lineTwo
                            : inputs.billingLineTwo,
                    billingZip:
                        inputs.billingSameAsAddress === true
                            ? inputs.zip
                            : inputs.billingZip,
                    billingCity:
                        inputs.billingSameAsAddress === true
                            ? inputs.city
                            : inputs.billingCity,
                    billingCountry:
                        inputs.billingSameAsAddress === true
                            ? inputs.country
                            : inputs.billingCountry,
                    remark: inputs.remark,
                    extraWarranty: inputs.extraWarranty,
                    warranty: buildWarrantyPayload(inputs.warranty),
                    sstIncluded: inputs.sstIncluded === true,
                    createdAt: orderInfo.createdAt || inputs.createdAt,
                    commenceDate: orderInfo.commenceDate,
                    productionApprovalDate:
                        orderInfo.productionApprovalDate,
                    blueprintApprovalDate: orderInfo.blueprintApprovalDate,
                    artist: orderInfo.artist ? orderInfo.artist._id : null,
                    producer: orderInfo.producer
                        ? orderInfo.producer._id
                        : null,
                    installer: orderInfo.installer
                        ? orderInfo.installer._id
                        : null,
                    purchaser: orderInfo.purchaser
                        ? orderInfo.purchaser._id
                        : null,
                    expenses: expensesData,
                    log: true
                };

                if ((superadmin || manager || outright) && isIpohAccount) {
                    updateData.totalCostBreakdown = buildTotalCostBreakdown(inputs);
                    updateData.totalCost = getTotalCostBreakdownSum(inputs);
                } else if (superadmin || manager || outright) {
                    updateData.totalCost =
                        inputs.totalCost === "" || inputs.totalCost == null
                            ? null
                            : parseFloat(inputs.totalCost);
                }

                // Add status if pending mode is enabled
                if (pendingMode) {
                    updateData.status = "pending";
                }

                const res = await userRequest.put(
                    `/orders/update/${predata._id}`,
                    updateData
                );

                if (res.data) {
                    alert("Your order has been updated");
                    // Refresh order data
                    fetchOrderData();
                    if (isIpohAccount) {
                        createIpohInvoice(res.data);
                    } else {
                        createCustomerInvoice(res.data);
                    }
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert(
                    "Failed to create order. Please check if the warranty is correct and belongs to this outlet. Please contact admin if you need support."
                );
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleEditCartProduct = (index) => {
        const line = cart[index];
        if (!line) return;
        const catalogProduct =
            products.find((p) => p._id === line._id) ||
            products.find((p) => p.title === line.title);
        if (!catalogProduct) {
            alert("Unable to find this product in the catalog.");
            return;
        }
        setProduct(catalogProduct);
        setColor(catalogProduct.color || []);
        const c = line.color || {};
        const linePriceTotal =
            c.price != null ? c.price : (line.price || 0) * (line.amount || 1);
        if (catalogProduct.title === "Awning") {
            setItemDetails({
                ...c,
                name: "Awning",
                price: linePriceTotal,
                quantity: line.amount,
                editCartIndex: index,
                initialAwningItems: groupAwningItemsFromColorItems(c.items || []),
            });
        } else if (catalogProduct.title === "Others") {
            // Item Name: PRIORITIZE the cart line's own data (c.name, c.type) over the shared catalog product
            // The catalog product's itemCode is shared across all "Others" lines and can be stale/wrong
            const isValidCustomCode = (val) => val && typeof val === 'string' && 
                val.trim() && val.trim().toLowerCase() !== 'others';
            
            const othersDisplay =
                // First, check the cart line's name (this is the custom code saved for THIS specific line)
                (isValidCustomCode(c.name) ? String(c.name).trim() : "") ||
                // Then check the cart line's type
                (isValidCustomCode(c.type) ? String(c.type).trim() : "") ||
                // Only fall back to catalog product's itemCode if the line has no custom code
                (isValidCustomCode(catalogProduct.itemCode) ? String(catalogProduct.itemCode).trim() : "") ||
                "";
            setItemDetails({
                ...c,
                name: catalogProduct.title,
                type: othersDisplay,
                itemCode: "OTHERS",
                price: linePriceTotal,
                quantity: line.amount,
                editCartIndex: index,
            });
        } else {
            setItemDetails({
                ...c,
                name: catalogProduct.title,
                price: linePriceTotal,
                quantity: line.amount,
                editCartIndex: index,
            });
        }
        window.scrollTo(0, 0);
        setColorPicker(true);
    };

    const handleAddProduct = (product, color, quantity) => {
        try {
            if (itemDetails.isMaterial) {
                // Add to materials cart instead of redux cart
                handleAddMaterial(product, color, quantity);
            } else if (itemDetails.isProductionMaterial) {
                // Add to production usage cart
                handleAddProductionMaterial(product, color, quantity);
            } else {
                // Merge all fields from itemDetails into activeColor to ensure all fields are included
                const activeColorData = color ? {
                    ...color,
                    // Ensure new fields are included even if color object exists
                    fabric: color.fabric || itemDetails.fabric,
                    fabricColor: color.fabricColor || itemDetails.fabricColor,
                    sidePanelColor: color.sidePanelColor || itemDetails.sidePanelColor,
                    transparency: color.transparency || itemDetails.transparency,
                    color: color.color || itemDetails.color,
                    ft: color.ft || itemDetails.ft,
                } : itemDetails;

                // Others: keep order `code` (activeColor.name) in sync with Item Name for API payload
                let normalizedActiveColor = activeColorData;
                if (
                    product.title === "Others" &&
                    (activeColorData.itemCode === "OTHERS" ||
                        itemDetails.itemCode === "OTHERS")
                ) {
                    const label = String(activeColorData.type || "").trim();
                    normalizedActiveColor = {
                        ...activeColorData,
                        name: label,
                        itemCode: "OTHERS",
                    };
                }

                const editIdx = itemDetails.editCartIndex;
                const canReplace =
                    editIdx != null &&
                    typeof editIdx === "number" &&
                    editIdx >= 0 &&
                    editIdx < cart.length;

                if (canReplace) {
                    dispatch(
                        replaceCartProductAtIndex({
                            index: editIdx,
                            ...product,
                            activeColor: normalizedActiveColor,
                            quantity,
                        })
                    );
                } else {
                    dispatch(
                        addProduct({
                            ...product,
                            activeColor: normalizedActiveColor,
                            quantity,
                        })
                    );
                }

                // NOTE: Previously this code updated the shared catalog Product's itemCode,
                // but that caused cross-contamination between different "Others" order lines.
                // Each order line's custom code is now stored in the order's products[].code field,
                // NOT in the shared catalog Product document.
            }
        } catch {}
    };

    const createMaterialLineUniqueId = (prefix) =>
        `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

    const handleAddMaterial = (product, color, quantity) => {
        const materialToAdd = {
            ...product,
            activeColor: color ? color : itemDetails,
            amount: quantity || 1,
            code: product.title,
            price: artist ? 0 : (color?.price || itemDetails?.price || 0), // Set price to 0 for drafter
            // Default classification code from order CO number (editable later)
            classificationCode: orderData?.coNumber || "",
            company: "",
            uniqueId: createMaterialLineUniqueId(
                `${color?.itemCode || itemDetails?.itemCode || "unknown"}_${color?.type || itemDetails?.type || "unknown"}`,
            ),
        };

        setMaterialsCart((prev) => [...prev, materialToAdd]);
    };

    const handleAddCustomAddOnMaterial = (name, quantity, price, sourceProduct) => {
        const trimmed = (name || "").trim();
        if (!trimmed) return;

        const numericQuantity = Number(quantity);
        const safeQuantity = Number.isFinite(numericQuantity) && numericQuantity > 0
            ? Math.floor(numericQuantity)
            : 1;

        const numericPrice = Number(price);
        const safePrice = artist
            ? 0
            : (Number.isFinite(numericPrice) && numericPrice >= 0 ? numericPrice : 0);

        const baseProduct = sourceProduct || {};
        const uniqueId = createMaterialLineUniqueId(`addon_${trimmed.toLowerCase()}`);

        setMaterialsCart((prev) => [
            ...prev,
            {
                ...baseProduct,
                _id: baseProduct._id,
                title: baseProduct.title || "Add On",
                activeColor: {
                    type: trimmed,
                    itemCode: "",
                    price: safePrice,
                },
                amount: safeQuantity,
                code: "",
                itemCode: "",
                type: trimmed,
                model: trimmed,
                price: safePrice,
                classificationCode: orderData?.coNumber || "",
                company: "",
                measurements: "",
                uniqueId,
            },
        ]);
    };

    const handleAddProductionMaterial = (product, color, quantity) => {
        const materialToAdd = {
            ...product,
            activeColor: color ? color : itemDetails,
            amount: quantity || 1,
            code: product.title,
            price: color?.price || itemDetails?.price || 0,
            // Create a unique identifier based on item code and type
            uniqueId: `${color?.itemCode || itemDetails?.itemCode || 'unknown'}_${color?.type || itemDetails?.type || 'unknown'}`,
        };

        setProductionUsageCart((prev) => {
            // Find existing material with same item code and type
            const existingIndex = prev.findIndex(
                (item) => item.uniqueId === materialToAdd.uniqueId
            );
            if (existingIndex >= 0) {
                // Update existing material quantity
                const updated = [...prev];
                updated[existingIndex].amount += quantity || 1;
                return updated;
            } else {
                // Add new material as separate item
                return [...prev, materialToAdd];
            }
        });
    };

    const handleMaterialQuantity = (material, quantityChange, newAmount) => {
        setMaterialsCart((prev) => {
            if (newAmount <= 0) {
                // Remove material if quantity becomes 0
                return prev.filter((item) => item.uniqueId !== material.uniqueId);
            } else {
                // Update quantity
                return prev.map((item) =>
                    item.uniqueId === material.uniqueId
                        ? { ...item, amount: newAmount }
                        : item
                );
            }
        });
    };

    const handleMaterialPrice = (material, newPrice) => {
        setMaterialsCart((prev) => {
            return prev.map((item) =>
                item.uniqueId === material.uniqueId
                    ? { ...item, price: newPrice }
                    : item
            );
        });
    };

    const handleMaterialClassificationCode = (material, classificationCode) => {
        setMaterialsCart((prev) => {
            return prev.map((item) =>
                item.uniqueId === material.uniqueId
                    ? { ...item, classificationCode: classificationCode }
                    : item
            );
        });
    };

    const handleMaterialCompany = (material, companyId) => {
        setMaterialsCart((prev) => {
            return prev.map((item) =>
                item.uniqueId === material.uniqueId
                    ? { ...item, company: companyId }
                    : item
            );
        });
    };

    const handleMaterialMeasurements = (material, measurements) => {
        setMaterialsCart((prev) => {
            return prev.map((item) =>
                item.uniqueId === material.uniqueId
                    ? { ...item, measurements: measurements }
                    : item
            );
        });
    };

    const handleProductionMaterialQuantity = (material, quantityChange, newAmount) => {
        setProductionUsageCart((prev) => {
            if (newAmount <= 0) {
                // Remove material if quantity becomes 0
                return prev.filter((item) => item.uniqueId !== material.uniqueId);
            } else {
                // Update quantity
                return prev.map((item) =>
                    item.uniqueId === material.uniqueId
                        ? { ...item, amount: newAmount }
                        : item
                );
            }
        });
    };

    const handlePosCreatePurchaseOrder = async (suppressAlert = false) => {
        if (materialsCart.length === 0) {
            alert("No materials added!!");
            return false;
        }

        const predata = orderData;

        if (currentUser) {
            try {
                const res = await userRequest.put(
                    `/orders/update/${predata._id}`,
                    {
                        materials: materialsCart.map((item) => {
                            const materialData = {
                                productId: item._id,
                                quantity: item.amount,
                                code: item.activeColor?.itemCode || item.itemCode || item.code,
                                img: item.img,
                                amount: item.amount,
                                type: item.activeColor?.type || item.color?.type || item.type,
                                itemCode: item.activeColor?.itemCode || item.color?.itemCode || item.itemCode,
                                model: item.activeColor?.name || item.model || item.title,
                                price: item.price || item.activeColor?.price || 0,
                            };
                            
                            // Only include classificationCode if it's not empty
                            if (item.classificationCode && item.classificationCode.trim() !== '') {
                                materialData.classificationCode = item.classificationCode;
                            }
                            
                            // Only include company if it's not empty
                            if (item.company && item.company.trim() !== '') {
                                materialData.company = item.company;
                            }

                            // Only include measurements if it's not empty
                            if (item.measurements && item.measurements.trim() !== '') {
                                materialData.measurements = item.measurements;
                            }
                            
                            // Preserve purchaseOrderId when material already belongs to a PO
                            if (item.purchaseOrderId) {
                                materialData.purchaseOrderId = item.purchaseOrderId;
                            }
                            
                            // Include record when it exists in the current order material
                            if (item.record) {
                                materialData.record = item.record;
                            }
                            
                            return materialData;
                        }),
                        // Keep existing order data
                        products: predata.products,
                        amount: predata.amount,
                        discount: predata.discount,
                        userId: predata.userId?._id,
                        referral: predata.referral?._id,
                        coNumber: predata.coNumber,
                        cashier: predata.cashier?._id,
                        remark: predata.remark,
                        createdAt: predata.createdAt,
                        commenceDate: predata.commenceDate,
                        productionApprovalDate: predata.productionApprovalDate,
                        blueprintApprovalDate: predata.blueprintApprovalDate,
                        artist: predata.artist?._id,
                        producer: predata.producer?._id,
                        installer: predata.installer?._id,
                        purchaser: predata.purchaser?._id,
                    }
                );

                if (res.data) {
                    if (!suppressAlert) {
                        alert("Purchase order has been updated");
                    }
                    // Refresh order data
                    fetchOrderData();
                    return true;
                } else {
                    alert("Server issue, please contact support");
                    return false;
                }
            } catch (err) {
                alert("Failed to update purchase order. Please try again.");
                console.error(err);
                return false;
            }
        } else {
            alert("Please login before updating purchase order");
            return false;
        }
    };

    const handleCreatePurchaseOrderFromSelection = async (selectedIndices, extras = {}) => {
        if (!selectedIndices || selectedIndices.length === 0) {
            alert("Please select at least one material to create a purchase order.");
            return;
        }
        if (!currentUser) {
            alert("Please login before creating a purchase order.");
            return;
        }

        const { dateOfIssue: extraDateOfIssue, poNumber: extraPoNumber, remarks: extraRemarks } = extras || {};

        const selectedMaterials = selectedIndices.map((i) => materialsCart[i]);
        const companies = [...new Set(selectedMaterials.map((m) => m.company).filter(Boolean))];
        if (companies.length > 1) {
            alert("Failed. Multiple items from different companies are selected. Please select items from the same company only.");
            return;
        }
        if (companies.length === 0 || !companies[0]) {
            alert("Failed. Selected items must have a company (supplier) assigned.");
            return;
        }

        const companyId = companies[0];
        const classificationCode = selectedMaterials[0]?.classificationCode || orderData?.coNumber || "";

        // Aggregate unique non-empty measurements from selected materials
        const aggregatedMeasurements = [
            ...new Set(
                selectedMaterials
                    .map((m) => (m.measurements ? String(m.measurements).trim() : ""))
                    .filter((v) => v !== "")
            ),
        ].join(" | ");

        try {
            const resolvedDateOfIssue = extraDateOfIssue
                ? new Date(extraDateOfIssue).toISOString()
                : new Date().toISOString();
            const resolvedPoNumber = typeof extraPoNumber === "string" ? extraPoNumber.trim() : "";
            const resolvedRemarks = typeof extraRemarks === "string" ? extraRemarks.trim() : "";

            const poRes = await userRequest.post("/purchaseOrders", {
                company: companyId,
                classificationCode,
                dateOfIssue: resolvedDateOfIssue,
                createdBy: currentUser._id,
                order: orderData?._id,
                measurements: aggregatedMeasurements,
                ...(resolvedPoNumber !== "" ? { poNumber: resolvedPoNumber } : {}),
                ...(resolvedRemarks !== "" ? { remarks: resolvedRemarks } : {}),
                materials: selectedMaterials.map((m) => ({
                    productId: m._id,
                    quantity: m.amount,
                    amount: m.amount,
                    code: m.activeColor?.itemCode || m.itemCode || m.code,
                    img: m.img,
                    type: m.activeColor?.type || m.type,
                    itemCode: m.activeColor?.itemCode || m.itemCode,
                    model: m.activeColor?.name || m.model,
                    price: m.price || 0,
                    measurements: m.measurements || "",
                })),
            });

            if (!poRes.data || !poRes.data._id) {
                alert("Failed to create purchase order.");
                return;
            }

            const purchaseOrderId = poRes.data._id;

            const poNumber = poRes.data.poNumber;
            setMaterialsCart((prev) =>
                prev.map((m, i) =>
                    selectedIndices.includes(i) ? { ...m, purchaseOrderId, purchaseOrderPoNumber: poNumber } : m
                )
            );

            // Persist to order - need to update with new purchaseOrderIds
            const updatedMaterials = materialsCart.map((m, i) => {
                const materialData = {
                    productId: m._id,
                    quantity: m.amount,
                    code: m.activeColor?.itemCode || m.itemCode || m.code,
                    img: m.img,
                    amount: m.amount,
                    type: m.activeColor?.type || m.type,
                    itemCode: m.activeColor?.itemCode || m.itemCode,
                    model: m.activeColor?.name || m.model,
                    price: m.price || 0,
                };
                if (m.classificationCode?.trim()) materialData.classificationCode = m.classificationCode;
                if (m.company?.trim()) materialData.company = m.company;
                if (m.measurements?.trim()) materialData.measurements = m.measurements;
                if (m.record) materialData.record = m.record;
                materialData.purchaseOrderId = selectedIndices.includes(i) ? purchaseOrderId : m.purchaseOrderId;
                return materialData;
            });

            await userRequest.put(`/orders/update/${orderData._id}`, {
                materials: updatedMaterials,
                products: orderData.products,
                amount: orderData.amount,
                discount: orderData.discount,
                userId: orderData.userId?._id,
                referral: orderData.referral?._id,
                coNumber: orderData.coNumber,
                cashier: orderData.cashier?._id,
                remark: orderData.remark,
                createdAt: orderData.createdAt,
                commenceDate: orderData.commenceDate,
                productionApprovalDate: orderData.productionApprovalDate,
                blueprintApprovalDate: orderData.blueprintApprovalDate,
                artist: orderData.artist?._id,
                producer: orderData.producer?._id,
                installer: orderData.installer?._id,
                purchaser: orderData.purchaser?._id,
            });

            alert("Purchase order created successfully.");
            fetchOrderData();
        } catch (err) {
            console.error(err);
            if (err.response?.data?.code === "AUTO_COUNT_PO_FAILED") {
                return { autocountFailed: true };
            }
            alert("Failed to create purchase order. Please try again.");
        }
    };

    const handlePosCreateProductionUsage = async (suppressAlert = false) => {
        if (productionUsageCart.length === 0) {
            alert("No production materials added!!");
            return false;
        }

        const predata = orderData;

        if (currentUser) {
            try {
                const res = await userRequest.put(
                    `/orders/update/${predata._id}`,
                    {
                        productionUsage: productionUsageCart.map((item) => {
                            const usageData = {
                                productId: item._id,
                                quantity: item.amount,
                                code: item.activeColor?.itemCode || item.itemCode || item.code,
                                img: item.img,
                                amount: item.amount,
                                type: item.activeColor?.type || item.color?.type || item.type,
                                itemCode: item.activeColor?.itemCode || item.color?.itemCode || item.itemCode,
                                model: item.activeColor?.name || item.model || item.title,
                                price: item.price || item.activeColor?.price || 0,
                            };
                            if (item.record) {
                                usageData.record = item.record;
                            }
                            return usageData;
                        }),
                        // Keep existing order data
                        materials: predata.materials,
                        products: predata.products,
                        amount: predata.amount,
                        discount: predata.discount,
                        userId: predata.userId?._id,
                        referral: predata.referral?._id,
                        coNumber: predata.coNumber,
                        cashier: predata.cashier?._id,
                        remark: predata.remark,
                        createdAt: predata.createdAt,
                        commenceDate: predata.commenceDate,
                        productionApprovalDate: predata.productionApprovalDate,
                        blueprintApprovalDate: predata.blueprintApprovalDate,
                        artist: predata.artist?._id,
                        producer: predata.producer?._id,
                        installer: predata.installer?._id,
                        purchaser: predata.purchaser?._id,
                    }
                );

                if (res.data) {
                    // Update local state immediately so UI reflects the change
                    setOrderData((prev) => ({
                        ...prev,
                        productionUsage: productionUsageCart.map((item) => {
                            const usageData = {
                                productId: item._id,
                                quantity: item.amount,
                                code: item.activeColor?.itemCode || item.itemCode || item.code,
                                img: item.img,
                                amount: item.amount,
                                type: item.activeColor?.type || item.color?.type || item.type,
                                itemCode: item.activeColor?.itemCode || item.color?.itemCode || item.itemCode,
                                model: item.activeColor?.name || item.model || item.title,
                                price: item.price || item.activeColor?.price || 0,
                            };
                            if (item.record) {
                                usageData.record = item.record;
                            }
                            return usageData;
                        }),
                    }));
                    if (!suppressAlert) {
                        alert("Production usage has been updated");
                    }
                    // Refresh order data
                    fetchOrderData();
                    return true;
                } else {
                    alert("Server issue, please contact support");
                    return false;
                }
            } catch (err) {
                alert("Failed to update production usage. Please try again.");
                console.error(err);
                return false;
            }
        } else {
            alert("Please login before updating production usage");
            return false;
        }
    };

    useEffect(() => {
        if (colorpicker === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [colorpicker]);

    

    useEffect(() => {
        if (salesmanApproveModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [salesmanApproveModalState]);

    useEffect(() => {
        if (salesmanRejectModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [salesmanRejectModalState]);

    useEffect(() => {
        if (customerApproveModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [customerApproveModalState]);

    useEffect(() => {
        if (addBlueprintModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [addBlueprintModalState]);

    useEffect(() => {
        if (approveDraftModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [approveDraftModalState]);

    useEffect(() => {
        if (rejectDraftModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [rejectDraftModalState]);

    useEffect(() => {
        if (customerRejectModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [customerRejectModalState]);

    useEffect(() => {
        if (rejectProductionModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [rejectProductionModalState]);

    useEffect(() => {
        if (approveProductionModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [approveProductionModalState]);

    useEffect(() => {
        if (approveInstallationModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [approveInstallationModalState]);

    useEffect(() => {
        if (submitDraftModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [submitDraftModalState]);

    useEffect(() => {
        if (submitPurchaseOrderModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [submitPurchaseOrderModalState]);

    useEffect(() => {
        if (submitProductionModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [submitProductionModalState]);

    useEffect(() => {
        if (deleteBlueprintModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [deleteBlueprintModalState]);

    useEffect(() => {
        if (usersData[0] === undefined) {
            getUsers();
        }
    }, [usersData]);

    useEffect(() => {
        if (companiesData.length === 0) {
            getCompanies();
        }
    }, [companiesData]);

    useEffect(() => {
        if (vehiclesData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getVehicles();
        }
    }, [vehiclesData, dispatch]);

    useEffect(() => {
        if (cashiersData[0] === undefined) {
            getCashiers();
        }
    }, [getCashiers, cashiersData]);

    useEffect(() => {
        if (artistsData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getArtists();
        }
    }, [getArtists, artistsData]);

    useEffect(() => {
        if (producersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getProducers();
        }
    }, [getProducers, producersData]);

    useEffect(() => {
        if (installersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getInstallers();
        }
    }, [getInstallers, installersData]);

    useEffect(() => {
        if (productionManagersData[0] === undefined) {
            getProductionManagers();
        }
    }, [getProductionManagers, productionManagersData]);

    useEffect(() => {
        if (purchasersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getPurchasers();
        }
    }, [getPurchasers, purchasersData]);

    useEffect(() => {
        getCategories(dispatch, productfilterCategory);
    }, [dispatch, filterList, productfilterCategory]);

    // Fetch products from database and create mappings (all branches see all products)
    useEffect(() => {
        const fetchProductMappings = async () => {
            try {
                const res = await publicRequest.get("/products/");
                const productsData = res.data;

                // Category title to mapping key (case-insensitive matching)
                const categoryMappingKeys = {
                    'acp': 'acpMapping',
                    'glass': 'glassMapping',
                    'polycarbonate': 'polyMapping',
                    'aluminium louver': 'aluminiumMapping',
                    'metal deck': 'metalDeckMapping',
                    'steel hollow': 'steelHollowMapping',
                    'gutter': 'pvcGutterMapping',
                    'flashing': 'flashingMapping',
                    'aluminum strip ceiling': 'aluminumStripCeilingMapping',
                    'add on': 'addOnMapping',
                };

                // Initialize empty mappings
                const newMappings = {
                    acpMapping: {},
                    glassMapping: {},
                    polyMapping: {},
                    aluminiumMapping: {},
                    metalDeckMapping: {},
                    steelHollowMapping: {},
                    pvcGutterMapping: {},
                    flashingMapping: {},
                    aluminumStripCeilingMapping: {},
                    addOnMapping: {},
                };

                // Populate mappings from products
                productsData.forEach((product) => {
                    const categoryTitle = product.category?.title?.toLowerCase();
                    const mappingKey = categoryMappingKeys[categoryTitle];

                    if (mappingKey && product.itemCode) {
                        newMappings[mappingKey][product.itemCode] = {
                            type: product.title,
                            pricePerLength: product.minimumPrice || 0,
                            pricePerUnit: product.minimumPrice || 0,
                        };
                    }
                });

                setProductMappings(newMappings);
            } catch (err) {
                console.error("Error fetching product mappings:", err);
            }
        };

        fetchProductMappings();
    }, [currentUser]);

    
    useEffect(() => {
        const fetchMaterialsData = async () => {
            try {
                const res = await publicRequest.get("/materials/");
                setMaterialsData(res.data);
            } catch (err) {
                console.error("Error fetching materials:", err);
            }
        };
        fetchMaterialsData();
    }, [currentUser]);

    // Build materials mapping: category + item code/name options for purchase/production pickers
    const materialsMappingForModal = (() => {
        const selectedCategoryTitle = product?.title?.toLowerCase();
        const mapping = {};
        materialsData.forEach((material) => {
            const materialCategoryTitle = material.category?.title?.toLowerCase();
            if (selectedCategoryTitle && materialCategoryTitle === selectedCategoryTitle && material.itemCode) {
                mapping[material.itemCode] = material.title;
            } else if (!selectedCategoryTitle && material.itemCode) {
                mapping[material.itemCode] = material.title;
            }
        });
        
        return mapping;
    })();

    // Fetch order data on component mount
    useEffect(() => {
        fetchOrderData();
    }, [orderId]);

    // Populate survey data from order data when order loads
    useEffect(() => {
        if (orderData && orderData.survey) {
            setSurveyData({
                pricing: orderData.survey.pricing || "",
                projectCompletion: orderData.survey.projectCompletion || "",
                qualityOfWork: orderData.survey.qualityOfWork || "",
                communication: orderData.survey.communication || "",
                maintenance: orderData.survey.maintenance || "",
                starRating: orderData.survey.starRating || "",
                comments: orderData.survey.comments || "",
                orderNumber: orderData.coNumber || "",
                customerName: orderData.userId?.name || "",
                address: "",
                installerName: orderData.installer?.name || "",
                date: orderData.survey.surveyDate || "",
                time: orderData.survey.time || "",
                icNumber: orderData.survey.ic || orderData.userId?.ic || "",
                signature: orderData.survey.signature || "",
            });
        }
    }, [orderData]);

    // Tab handling
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    // Define tabs - Progression, customer, order info, blueprint, purchase order, production, survey, history, products
    const allTabs = [
        { id: "progression", label: "Progression", icon: FiTrendingUp },
        { id: "customer", label: "Customer", icon: FiUser },
        { id: "orderInfo", label: "Order Info", icon: FiFileText },
        { id: "blueprint", label: "Blueprint", icon: FiFileText },
        { id: "purchaseOrder", label: "Purchase Order", icon: FiPackage },
        { id: "production", label: "Production", icon: FiSettings },
        { id: "survey", label: "Survey", icon: FiClipboard },
        { id: "history", label: "History", icon: FiActivity },
        { id: "journal", label: "Journal", icon: FiBook },
        { id: "products", label: "Products", icon: FiShoppingCart },
    ];

    // Role-based tab access control
    const userType = currentUser?.type;
    const isSuperAdmin = currentUser?.isSuperAdmin === true;
    const accountId = (value) => {
        if (value == null) return "";
        if (typeof value === "object") {
            const id = value._id ?? value.id;
            return id != null ? String(id) : "";
        }
        return String(value);
    };
    const restrictedProductionStaffId = "691c03f0f925e9390aada294";
    const hideProductionTab =
        userType === "staff" &&
        (accountId(currentUser?._id) === restrictedProductionStaffId ||
            accountId(currentUser?.principle) === restrictedProductionStaffId);

    const tabAccessMap = {
        progression: userType !== "user",
        customer: userType !== "user",
        orderInfo: userType === "staff" || userType === "manager" || userType === "outright" || isSuperAdmin,
        purchaseOrder:
            userType === "purchaser" ||
            userType === "manager" ||
            userType === "outright" ||
            isSuperAdmin,
        blueprint: userType === "drafter" || userType === "manager" || userType === "outright" || userType === "staff" || isSuperAdmin,
        production:
            userType === "production" ||
            userType === "productionManager" ||
            userType === "purchaser" ||
            userType === "manager" ||
            userType === "outright" ||
            (userType === "staff" && !hideProductionTab) ||
            isSuperAdmin,
        survey: userType === "staff" || userType === "user" || userType === "manager" || userType === "outright" || isSuperAdmin,
        history: true,
        journal:
            userType === "installer" ||
            userType === "installerManager" ||
            userType === "staff" || // salesman already had access to Journal
            userType === "user" ||
            userType === "manager" ||
            userType === "outright" ||
            isSuperAdmin,
        products: userType === "staff" || userType === "manager" || isSuperAdmin || userType === "purchaser" || userType === "outright",
    };

    const tabs = allTabs.filter(tab => {
        if (process.env.REACT_APP_PROJECT === "JINSORA" && tab.id === "blueprint") return false;
        return tabAccessMap[tab.id] ?? false;
    });

    useEffect(() => {
        if (hasAppliedRoleDefaultTab.current || !currentUser) return;

        if (currentUser.type === "producer" || currentUser.type === "production") {
            setActiveTab("production");
        } else if (
            currentUser.type === "installer" ||
            currentUser.type === "installerManager"
        ) {
            setActiveTab("journal");
        }

        hasAppliedRoleDefaultTab.current = true;
    }, [currentUser]);

    // Mobile tabs: detect viewport and close menu when resizing to desktop
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobileTabs(mobile);
            if (!mobile) setTabsMenuOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Close tabs menu on Escape
    useEffect(() => {
        if (!tabsMenuOpen || !isMobileTabs) return;
        const handleEscape = (e) => {
            if (e.key === "Escape") setTabsMenuOpen(false);
        };
        window.addEventListener("keydown", handleEscape);
        return () => window.removeEventListener("keydown", handleEscape);
    }, [tabsMenuOpen, isMobileTabs]);

    // Prefill form data when editing existing order
    useEffect(() => {
        if ((orderData && vehiclesData.length > 0 && cashiersData.length > 0 && !cartLoaded) || (process.env.REACT_APP_PROJECT === "JINSORA" && orderData && cashiersData.length > 0 && !cartLoaded)) {
            const existingOrder = orderData;
            setInputs((prev) => ({
                ...prev,
                createdAt: existingOrder.createdAt || "",
                vehicle: existingOrder.userId ? existingOrder.userId._id : "",
                referral: existingOrder.referral
                    ? existingOrder.referral._id
                    : "",

                coNumber: existingOrder.coNumber || "",
                paymentType: existingOrder.paymentType || "",
                estimatedInstallationDays: existingOrder.estimatedInstallationDays || "",
                firstPayment: existingOrder.firstPayment || "",
                ...Object.fromEntries(
                    ORDER_FORM_PAYMENTS.map((field) => [
                        field.name,
                        existingOrder[field.name] ?? "",
                    ])
                ),
                totalCost: existingOrder.totalCost ?? "",
                ...getTotalCostBreakdownInputs(existingOrder),
                cashier: existingOrder.cashier ? existingOrder.cashier._id : "",
                lineOne: existingOrder.lineOne || "",
                lineTwo: existingOrder.lineTwo || "",
                zip: existingOrder.zip || "",
                city: existingOrder.city || "",
                country: existingOrder.country || "",
                billingLineOne:
                    existingOrder.billingLineOne ?? existingOrder.lineOne ?? "",
                billingLineTwo:
                    existingOrder.billingLineTwo ?? existingOrder.lineTwo ?? "",
                billingZip: existingOrder.billingZip ?? existingOrder.zip ?? "",
                billingCity: existingOrder.billingCity ?? existingOrder.city ?? "",
                billingCountry:
                    existingOrder.billingCountry ?? existingOrder.country ?? "",
                billingSameAsAddress: (() => {
                    const eo = existingOrder;
                    const hasBilling =
                        (eo.billingLineOne != null && eo.billingLineOne !== "") ||
                        (eo.billingLineTwo != null && eo.billingLineTwo !== "") ||
                        (eo.billingZip != null && eo.billingZip !== "") ||
                        (eo.billingCity != null && eo.billingCity !== "") ||
                        (eo.billingCountry != null && eo.billingCountry !== "");
                    if (!hasBilling) return false;
                    return (
                        (eo.billingLineOne || "") === (eo.lineOne || "") &&
                        (eo.billingLineTwo || "") === (eo.lineTwo || "") &&
                        (eo.billingZip || "") === (eo.zip || "") &&
                        (eo.billingCity || "") === (eo.city || "") &&
                        (eo.billingCountry || "") === (eo.country || "")
                    );
                })(),
                remark: existingOrder.remark || "",
                extraWarranty: existingOrder.extraWarranty || "",
                sstIncluded: existingOrder.sstIncluded === true,
                warranty: existingOrder.warranty
                    ? {
                        leakageWarranty: existingOrder.warranty.leakageWarranty ?? 1,
                        acpWarranty: existingOrder.warranty.acpWarranty ?? 5,
                        aluminiumCBondWarranty: existingOrder.warranty.aluminiumCBondWarranty,
                        structureWarranty: existingOrder.warranty.structureWarranty ?? 10,
                        glassWarranty: existingOrder.warranty.glassWarranty ?? 1,
                        polycarbonateWarranty: existingOrder.warranty.polycarbonateWarranty,
                        metaldeckWarranty: existingOrder.warranty.metaldeckWarranty,
                    }
                    : {
                        leakageWarranty: 1,
                        acpWarranty: 5,
                        structureWarranty: 10,
                        glassWarranty: 1,
                    },
                discount: existingOrder.discount || 0,
            }));

            // Prefill order info
            setOrderInfo((prev) => ({
                ...prev,
                artist: existingOrder.artist || null,
                producer: existingOrder.producer || null,
                installer: existingOrder.installer || null,
                purchaser: existingOrder.purchaser || null,
                productionManager: existingOrder.productionManager || null,
                cashier: existingOrder.cashier || null,
                secondSalesperson:
                    existingOrder.secondSalesperson?._id ||
                    existingOrder.secondSalesperson ||
                    "",
                status: existingOrder.status || "",
                createdAt: existingOrder.createdAt || "",
                commenceDate: existingOrder.commenceDate || "",
                uploadedDraftDate: existingOrder.uploadedDraftDate || "",
                blueprintApprovalDate: existingOrder.blueprintApprovalDate || "",
                salesmanApprovedDate: existingOrder.salesmanApprovedDate || "",
                salesmanRejectedDate: existingOrder.salesmanRejectedDate || "",
                customerApprovedDate: existingOrder.customerApprovedDate || "",
                pendingPurchaseApprovalDate: existingOrder.pendingPurchaseApprovalDate || "",
                purchasingDate: existingOrder.purchasingDate || "",
                productionDate: existingOrder.productionDate || "",
                productionApprovalDate: existingOrder.productionApprovalDate || "",
                installingDate: existingOrder.installingDate || "",
                installApprovedDate: existingOrder.installApprovedDate || "",
                depositDate: existingOrder.depositDate || "",
                surveyDate: existingOrder.survey?.surveyDate || "",
                lineOne: existingOrder.lineOne || "",
                lineTwo: existingOrder.lineTwo || "",
                zip: existingOrder.zip || "",
                city: existingOrder.city || "",
                country: existingOrder.country || "",
                threeDPrint: existingOrder.threeDPrint || false,
                threedDrawing: existingOrder.expenses?.threedDrawing || 0,
            }));
            setSurveyData((prev) => ({
                ...prev,
                orderNumber: existingOrder.invoiceId || "",
                customerName: existingOrder.userId?.name || "",
                address: existingOrder.address || "",
                installerName: existingOrder.installer?.name || "",
                // Populate survey responses if they exist
                pricing: existingOrder.survey?.pricing || prev.pricing,
                projectCompletion: existingOrder.survey?.projectCompletion || prev.projectCompletion,
                qualityOfWork: existingOrder.survey?.qualityOfWork || prev.qualityOfWork,
                communication: existingOrder.survey?.communication || prev.communication,
                maintenance: existingOrder.survey?.maintenance || prev.maintenance,
                starRating: existingOrder.survey?.starRating || prev.starRating,
                comments: existingOrder.survey?.comments || prev.comments,
                signature: existingOrder.survey?.signature || prev.signature,
                date: existingOrder.survey?.surveyDate || prev.date,
                facebookReviewUrl: existingOrder.survey?.facebookReview?.url || "",
                googleReviewUrl: existingOrder.survey?.googleReview?.url || "",
            }));

            // Prefill expenses data if available
            if (existingOrder.expenses) {
                setExpensesData({
                    creditCard: existingOrder.expenses.creditCard || 0.00,
                    commission: existingOrder.expenses.commission || 0.00,
                    freeGive: existingOrder.expenses.freeGive || 0.00,
                    crane: existingOrder.expenses.crane || 0.00,
                    voucher: existingOrder.expenses.voucher || 0.00,
                    drawing: existingOrder.expenses.drawing || 0.00,
                    sponsor: existingOrder.expenses.sponsor || 0.00,
                    snSstCn: existingOrder.expenses.snSstCn || 0.00,
                    swSstCn: existingOrder.expenses.swSstCn || 0.00,
                    sstCn: existingOrder.expenses.sstCn || 0.00,
                    threedDrawing: existingOrder.expenses.threedDrawing || 0.00,
                    accessoryCosting: existingOrder.expenses.accessoryCosting || 0.00,
                });
            }

            // Prefill materials cart
            if (existingOrder.materials && existingOrder.materials.length > 0) {
                const materialsForCart = existingOrder.materials.map((material, idx) => ({
                    _id: material.productId,
                    title: material.code,
                    code: material.code,
                    img: material.img,
                    amount: material.amount || material.quantity,
                    price: material.price || 0,
                    classificationCode: material.classificationCode || existingOrder.coNumber || '',
                    company: material.company?._id || material.company || '',
                    measurements: resolveMaterialMeasurements(material),
                    materialId: material._id,
                    purchaseOrderId: material.purchaseOrderId?._id || material.purchaseOrderId,
                    purchaseOrderPoNumber: material.purchaseOrderId?.poNumber,
                    record: material.record,
                    itemCode: material.itemCode,
                    type: material.type,
                    model: material.model,
                    activeColor: {
                        itemCode: material.itemCode,
                        type: material.type,
                        name: material.model, // Include model/name for proper saving
                        price: material.price || 0,
                    },
                    uniqueId: `${material.itemCode || 'unknown'}_${material.type || 'unknown'}_${material._id || idx}`,
                }));
                setMaterialsCart(materialsForCart);
            }

            // Prefill production usage cart only if it exists (don't default to purchase order materials)
            if (existingOrder.productionUsage && existingOrder.productionUsage.length > 0) {
                const productionUsageForCart = existingOrder.productionUsage.map(material => ({
                    _id: material.productId,
                    title: material.code,
                    code: material.code,
                    img: material.img,
                    amount: material.amount || material.quantity,
                    price: material.price || 0,
                    record: material.record,
                    activeColor: {
                        itemCode: material.itemCode,
                        type: material.type,
                        name: material.model, // Include model/name for proper saving
                        price: material.price || 0,
                    },
                    uniqueId: `${material.itemCode || 'unknown'}_${material.type || 'unknown'}`,
                }));
                setProductionUsageCart(productionUsageForCart);
            }

            // Prefill products cart (Redux cart) with existing order products
            if (existingOrder.products && existingOrder.products.length > 0) {
                // Clear cart first to prevent duplicates
                dispatch(clearCart());
                
                existingOrder.products.forEach(product => {
                    // For "Others" items, preserve the custom code in BOTH name AND type
                    // This ensures the code is correctly saved even if one field is empty
                    const isOthersItem = product.itemCode === "OTHERS" || product.itemCode === "others";
                    const hasValidCustomCode = product.code && 
                        typeof product.code === 'string' && 
                        product.code.trim() && 
                        product.code.trim().toLowerCase() !== 'others';
                    
                    // For Others items with a valid custom code, use that code for type
                    // Otherwise fall back to the normal type derivation
                    const typeValue = isOthersItem && hasValidCustomCode
                        ? product.code.trim()
                        : (product.productId?.category?.title || product.productId?.title || product.typeDescription || product.type);
                    const ipohFields = ipohAwningFieldsFromCode(product.code, product.title);
                    
                    dispatch(
                        addProduct({
                            _id: product.productId?._id || product.productId,
                            title: product.productId?.category?.title || product.productId?.title || product.typeDescription || product.code || 'Product',
                            model: product.model,
                            img: product.img,
                            // Preserve record, createdBy, and createdAt from existing product
                            record: product.record,
                            createdBy: product.createdBy?._id || product.createdBy,
                            createdAt: product.createdAt,
                            activeColor: {
                                name: product.code,
                                customTitle: product.title,
                                ...(ipohFields || {}),
                                ...(ipohFields
                                    ? { ipohSpecItem: product.items?.[0] || {} }
                                    : {}),
                                price: product.price,
                                type: typeValue,
                                itemCode: product.itemCode,
                                frameColor: product.frameColor,
                                sizeWidth: product.size ? product.size.split("' (w)")[0] : null,
                                sizeLength: product.size ? (product.size.includes("' (h)") 
                                    ? product.size.split("x ")[1]?.split("' (l)")[0] 
                                    : product.size.split("x ")[1]?.replace("' (l)", "")) : null,
                                sizeHeight: product.size && product.size.includes("' (h)") 
                                    ? product.size.split("x ")[2]?.replace("' (h)", "") : null,
                                // New fields for Motorized Zip Blinds, Zip Blinds Manual Series, and Retractable Awning
                                fabric: product.fabric,
                                fabricColor: product.fabricColor,
                                sidePanelColor: product.sidePanelColor,
                                transparency: product.transparency,
                                color: product.color,
                                // Stainless Steel Gutter and T-Light specific field
                                ft: product.ft || product.tLightSize, // Support both old tLightSize and new ft field
                                // Gutter specific fields
                                giGutterSize: product.giGutterSize,
                                stainlessSteelGutterSize: product.stainlessSteelGutterSize,
                                aluminumGutterType: product.aluminumGutterType,
                                aluminumGutterSizeWidth: product.aluminumGutterSize ? product.aluminumGutterSize.split("' (w)")[0] : null,
                                aluminumGutterSizeLength: product.aluminumGutterSize ? product.aluminumGutterSize.split("x ")[1]?.replace("' (l)", "") : null,
                                // Steel Hollow fields
                                steelhollowItemCode: product.steelhollowItemCode,
                                steelhollowType: product.steelhollowType,
                                // Awning fields
                                acpItemCode: product.acpItemCode,
                                acpType: product.acpType,
                                acpFrameColor: product.acpFrameColor,
                                acpSizeWidth: product.acpSize ? product.acpSize.split("' (w)")[0] : null,
                                acpSizeLength: product.acpSize ? product.acpSize.split("x ")[1]?.replace("' (l)", "") : null,
                                glassItemCode: product.glassItemCode,
                                glassType: product.glassType,
                                glassSizeWidth: product.glassSize ? product.glassSize.split("' (w)")[0] : null,
                                glassSizeLength: product.glassSize ? product.glassSize.split("x ")[1]?.replace("' (l)", "") : null,
                                metalDeckItemCode: product.metalDeckItemCode,
                                metalDeckType: product.metalDeckType,
                                metalDeckSizeWidth: product.metalDeckSize ? product.metalDeckSize.split("' (w)")[0] : null,
                                metalDeckSizeLength: product.metalDeckSize ? product.metalDeckSize.split("x ")[1]?.replace("' (l)", "") : null,
                                polycarbonateItemCode: product.polycarbonateItemCode,
                                polycarbonateType: product.polycarbonateType,
                                polycarbonateSizeWidth: product.polycarbonateSize ? product.polycarbonateSize.split("' (w)")[0] : null,
                                polycarbonateSizeLength: product.polycarbonateSize ? product.polycarbonateSize.split("x ")[1]?.replace("' (l)", "") : null,
                                // Awning category items array
                                items: product.items || [],
                            },
                            quantity: product.amount || product.quantity || 1,
                        })
                    );
                });
                
                setCartLoaded(true);
            }
        }
    }, [orderData, vehiclesData, cashiersData, dispatch, cartLoaded]);

    // Effect to display existing signature on canvas when survey data is loaded
    useEffect(() => {
        if (surveyData.signature && signatureRef) {
            const canvas = signatureRef;
            const ctx = canvas.getContext("2d");
            const img = new Image();
            
            img.onload = () => {
                // Clear the canvas first
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // Draw the signature image
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            };
            
            img.onerror = () => {
                console.error("Failed to load signature image");
            };
            
            img.src = surveyData.signature;
        }
    }, [surveyData.signature, signatureRef]);

    // Show loading state while data is being fetched
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg">Loading order data...</div>
            </div>
        );
    }

    // Show message if no order data is available
    if (!orderData) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg">No order data found.</div>
            </div>
        );
    }

    return (
        <div className="py-4 px-4 md:px-12" onChangeCapture={capitalizeTextInputOnChange}>
            {/* Header Actions */}
            {isMobileTabs ? (
                <div className="mb-6">
                    <div className="space-y-3">
                        <button
                            onClick={() => history.goBack()}
                            className="w-full px-4 py-2 text-white bg-black rounded-lg hover:bg-blue-400 hover:text-black transition-colors duration-200 shadow-md hover:shadow-lg flex items-center justify-center space-x-2"
                        >
                            <FiArrowLeft className="h-5 w-5" />
                            <span>Back</span>
                        </button>
                        {activeTab === "production" &&
                            (superadmin || manager || production || hasProductionManagerAccess) &&
                            orderData?.status === "production" && (
                                <button
                                    onClick={handleConfirmProductionCompleted}
                                    className="w-full px-4 py-2 text-white bg-green-600 rounded-lg hover:bg-green-500 transition-colors duration-200 shadow-md hover:shadow-lg flex items-center justify-center space-x-2"
                                >
                                    <FiSettings className="h-5 w-5" />
                                    <span>Confirm Production</span>
                                </button>
                            )}
                    </div>
                    <h1 className="text-2xl font-bold text-gray-800 mt-4">
                        Order {orderData?.invoiceId || ""}
                    </h1>
                </div>
            ) : (
                <div className="flex justify-between items-center mb-6">
                    <button
                        onClick={() => history.goBack()}
                        className="px-4 py-2 text-white bg-black rounded-lg hover:bg-blue-400 hover:text-black transition-colors duration-200 shadow-md hover:shadow-lg flex items-center space-x-2"
                    >
                        <FiArrowLeft className="h-5 w-5" />
                        <span>Back</span>
                    </button>
                    <h1 className="text-2xl font-bold text-gray-800">
                        Order {orderData?.invoiceId || ""}
                    </h1>
                </div>
            )}

            {/* Tabs */}
            <div className="border-b border-gray-200 mb-6 edit-order-tabs-wrapper">
                {/* Desktop: horizontal tab list */}
                <div className="edit-order-tabs-container edit-order-tabs-desktop md:flex md:flex-nowrap md:justify-start md:space-x-8 md:gap-0 md:overflow-visible pb-2 md:pb-0">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`edit-order-tab-button flex items-center justify-center md:justify-start pb-4 px-1 border-b-2 font-medium text-sm md:whitespace-nowrap ${
                                activeTab === tab.id
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                            }`}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            <tab.icon className="w-5 h-5 mr-2" />
                            {tab.label}
                        </button>
                    ))}
                </div>
                {/* Mobile: menu icon + current tab label, open menu shows all tabs */}
                {isMobileTabs && (
                    <>
                        <div className="edit-order-tabs-mobile-header">
                            <span className="edit-order-tabs-mobile-current">
                                {(() => {
                                    const active = tabs.find((t) => t.id === activeTab);
                                    if (!active) return "Tabs";
                                    const Icon = active.icon;
                                    return (
                                        <>
                                            <Icon className="edit-order-tabs-mobile-current-icon" />
                                            {active.label}
                                        </>
                                    );
                                })()}
                            </span>
                            <button
                                type="button"
                                className="edit-order-tabs-mobile-menu-btn"
                                onClick={() => setTabsMenuOpen((o) => !o)}
                                aria-label={tabsMenuOpen ? "Close tabs menu" : "Open tabs menu"}
                            >
                                {tabsMenuOpen ? (
                                    <Close className="edit-order-tabs-mobile-menu-icon" />
                                ) : (
                                    <FiMenu className="edit-order-tabs-mobile-menu-icon" />
                                )}
                            </button>
                        </div>
                        {tabsMenuOpen && (
                            <>
                                <div
                                    className="edit-order-tabs-mobile-backdrop"
                                    onClick={() => setTabsMenuOpen(false)}
                                    aria-hidden="true"
                                />
                                <div className="edit-order-tabs-mobile-menu">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab.id}
                                            type="button"
                                            className={`edit-order-tabs-mobile-menu-item ${
                                                activeTab === tab.id ? "edit-order-tabs-mobile-menu-item-active" : ""
                                            }`}
                                            onClick={() => {
                                                handleTabChange(tab.id);
                                                setTabsMenuOpen(false);
                                            }}
                                        >
                                            <tab.icon className="edit-order-tabs-mobile-menu-item-icon" />
                                            {tab.label}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            {/* Tab Content */}
            <div className="bg-white rounded-lg shadow">
                {activeTab === "orderInfo" && (
                    <OrderInfoTab
                        orderData={orderData}
                        orderInfo={orderInfo}
                        handleOrderInfoChange={handleOrderInfoChange}
                        handleSaveOrderInfo={handleSaveOrderInfo}
                        artistsData={artistsData}
                        producersData={producersData}
                        installersData={installersData}
                        purchasersData={purchasersData}
                        productionManagersData={productionManagersData}
                        cashiersData={cashiersData}
                        showIndoorSalesman={isIpohAccount}
                        indoorSalesmanOptions={indoorSalesmanOptions}
                        superadmin={superadmin}
                        manager={manager}
                        outright={outright}
                        staff={staff}
                    />
                )}

                {activeTab === "products" && (
                    <ProductsTab
                        cart={cart}
                        total={total}
                        inputs={inputs}
                        handleChange={handleChange}
                        handleQuantity={handleQuantity}
                        handlePosCreateOrder={handlePosCreateOrder}
                        hideExpenses={isIpohAccount}
                        useTotalCostBreakdown={isIpohAccount}
                        cashierMode={cashierMode}
                        setCashierMode={setCashierMode}
                        setFilterList={setFilterList}
                        products={products}
                        setColor={setColor}
                        setProduct={setProduct}
                        setItemDetails={setItemDetails}
                        setColorPicker={setColorPicker}
                        NumberFormatter={NumberFormatter}
                        superadmin={superadmin}
                        manager={manager}
                        staff={staff}
                        outright={outright}
                        expenses={expensesData}
                        handleExpensesChange={handleExpensesChange}
                        orderData={orderData}
                        pendingMode={pendingMode}
                        setPendingMode={setPendingMode}
                        sstIncluded={inputs.sstIncluded === true}
                        setSstIncluded={(value) =>
                            setInputs((prev) => ({ ...prev, sstIncluded: value }))
                        }
                        zipBlindsModelMapping={zipBlindsModelMapping}
                        modelToItemCodeZipBlinds={modelToItemCodeZipBlinds}
                        zipBlindsFabricOptions={zipBlindsFabricOptions}
                        zipBlindsManualModelMapping={zipBlindsManualModelMapping}
                        modelToItemCodeZipBlindsManual={modelToItemCodeZipBlindsManual}
                        zipBlindsManualColorOptions={zipBlindsManualColorOptions}
                        zipBlindsManualTransparencyOptions={zipBlindsManualTransparencyOptions}
                        retractableAwningModelMapping={retractableAwningModelMapping}
                        modelToItemCodeRetractableAwning={modelToItemCodeRetractableAwning}
                        retractableAwningFabricOptions={retractableAwningFabricOptions}
                        retractableAwningFabricColorOptions={retractableAwningFabricColorOptions}
                        retractableAwningSidePanelColorOptions={retractableAwningSidePanelColorOptions}
                        onEditCartProduct={handleEditCartProduct}
                    />
                )}

                {activeTab === "purchaseOrder" && tabAccessMap.purchaseOrder && (
                    <PurchaseOrderTab
                        materialsCart={materialsCart}
                        inputs={inputs}
                        handleChange={handleChange}
                        handleMaterialQuantity={handleMaterialQuantity}
                        handleMaterialPrice={handleMaterialPrice}
                        handleMaterialClassificationCode={handleMaterialClassificationCode}
                        handleMaterialCompany={handleMaterialCompany}
                        handleMaterialMeasurements={handleMaterialMeasurements}
                        handleAddCustomAddOnMaterial={handleAddCustomAddOnMaterial}
                        handlePosCreatePurchaseOrder={handlePosCreatePurchaseOrder}
                        handleCreatePurchaseOrderFromSelection={handleCreatePurchaseOrderFromSelection}
                        cashierMode={cashierMode}
                        setCashierMode={setCashierMode}
                        setFilterList={setFilterList}
                        products={products}
                        setColor={setColor}
                        setProduct={setProduct}
                        setItemDetails={setItemDetails}
                        setColorPicker={setColorPicker}
                        orderData={orderData}
                        handleSubmitPurchaseOrder={handleSubmitPurchaseOrder}
                        handleApprovePurchaseOrder={handleApprovePurchaseOrder}
                        handleRejectPurchaseOrder={handleRejectPurchaseOrder}
                        handleCompletePurchase={handleCompletePurchase}
                        handleConfirmPOArrived={handleConfirmPOArrived}
                        superadmin={superadmin}
                        manager={manager}
                        outright={outright}
                        production={production}
                        artist={artist}
                        companiesData={companiesData}
                        currentUser={currentUser}
                        purchaser={purchaser}
                    />
                )}

                {activeTab === "production" && tabAccessMap.production && (
                    <ProductionTab
                        productionUsageCart={productionUsageCart}
                        handleProductionMaterialQuantity={handleProductionMaterialQuantity}
                        handlePosCreateProductionUsage={handlePosCreateProductionUsage}
                        setFilterList={setFilterList}
                        products={products}
                        setColor={setColor}
                        setProduct={setProduct}
                        setItemDetails={setItemDetails}
                        setColorPicker={setColorPicker}
                        orderData={orderData}
                        handleSubmitProduction={handleSubmitProduction}
                        handleCompleteProduction={handleCompleteProduction}
                        handleConfirmProductionCompleted={handleConfirmProductionCompleted}
                        setApproveProductionModalState={setApproveProductionModalState}
                        setRejectProductionModalState={setRejectProductionModalState}
                        superadmin={superadmin}
                        manager={manager}
                        production={production}
                        productionManager={productionManager}
                        hasProductionManagerAccess={hasProductionManagerAccess}
                        outright={outright}
                        hq={hq}
                    />
                )}

                {activeTab === "customer" && (
                    <CustomerTab orderData={orderData} />
                )}

                {activeTab === "blueprint" && (
                    <BlueprintTab
                        orderData={orderData}
                        orderProducts={orderData?.products || []}
                        setAddBlueprintModalState={setAddBlueprintModalState}
                        handleDeleteBlueprint={handleDeleteBlueprint}
                        handleSubmitDraft={handleSubmitDraft}
                        setApproveDraftModalState={setApproveDraftModalState}
                        setRejectDraftModalState={setRejectDraftModalState}
                        setSalesmanApproveModalState={setSalesmanApproveModalState}
                        setSalesmanRejectModalState={setSalesmanRejectModalState}
                        setCustomerApproveModalState={setCustomerApproveModalState}
                        setCustomerRejectModalState={setCustomerRejectModalState}
                        superadmin={superadmin}
                        manager={manager}
                        isRegularUser={isRegularUser}
                        artist={artist}
                        productionManager={productionManager}
                        hasProductionManagerAccess={hasProductionManagerAccess}
                        staff={staff}
                        outright={outright}
                        checkedBlueprints={checkedBlueprints}
                        handleToggleBlueprintCheck={handleToggleBlueprintCheck}
                        areAllBlueprintsChecked={areAllBlueprintsChecked}
                        handleBlueprintFieldChange={handleBlueprintFieldChange}
                    />
                )}

                {activeTab === "survey" && (
                    <SurveyTab
                        surveyData={surveyData}
                        orderData={orderData}
                        handleSurveyChange={handleSurveyChange}
                        signatureRef={signatureRef}
                        setSignatureRef={setSignatureRef}
                        clearSignature={clearSignature}
                        handleSignatureEnd={handleSignatureEnd}
                        saveSurvey={saveSurvey}
                        generateSurveyPDFOnly={generateSurveyPDFOnly}
                        isSavingSurvey={isSavingSurvey}
                        superadmin={superadmin}
                        staff={staff}
                        installer={installer}
                        installerManager={installerManager}
                        isRegularUser={isRegularUser}
                        handleReviewStatusChange={handleReviewStatusChange}
                    />
                )}

                {activeTab === "history" && (
                    <HistoryTab 
                        orderData={orderData}
                        confirmCompletedModalState={confirmCompletedModalState}
                        setConfirmCompletedModalState={setConfirmCompletedModalState}
                        handleConfirmCompleted={handleConfirmCompleted}
                        isConfirmingCompleted={isConfirmingCompleted}
                        superadmin={superadmin}
                        manager={manager}
                        outright={outright}
                        hq={hq}
                        staff={staff}
                        purchaser={purchaser}
                    />
                )}

                {activeTab === "journal" && (
                    <JournalTab 
                        orderData={orderData}
                        installerManager={installerManager}
                        productionManager={productionManager}
                        manager={manager}
                        currentUser={currentUser}
                        outright={outright}
                        setOrderData={setOrderData}
                    />
                )}

                {activeTab === "progression" && (
                    <div className="p-6">
                        <ProcessFlowChart orderData={orderData} />
                    </div>
                )}

            </div>

            {/* Modals */}
            <ProductPickerModal
                colorpicker={colorpicker}
                setColorPicker={setColorPicker}
                itemDetails={itemDetails}
                handleSetItemDetails={handleSetItemDetails}
                handleAddProduct={handleAddProduct}
                product={product}
                setItemDetails={setItemDetails}
                artist={artist}
                isIpohAccount={isIpohAccount}
                zipBlindsModelMapping={zipBlindsModelMapping}
                modelToItemCodeZipBlinds={modelToItemCodeZipBlinds}
                zipBlindsFabricOptions={zipBlindsFabricOptions}
                zipBlindsManualModelMapping={zipBlindsManualModelMapping}
                modelToItemCodeZipBlindsManual={modelToItemCodeZipBlindsManual}
                zipBlindsManualColorOptions={zipBlindsManualColorOptions}
                zipBlindsManualTransparencyOptions={zipBlindsManualTransparencyOptions}
                retractableAwningModelMapping={retractableAwningModelMapping}
                modelToItemCodeRetractableAwning={modelToItemCodeRetractableAwning}
                retractableAwningFabricOptions={retractableAwningFabricOptions}
                retractableAwningFabricColorOptions={retractableAwningFabricColorOptions}
                retractableAwningSidePanelColorOptions={retractableAwningSidePanelColorOptions}
                acpMapping={productMappings.acpMapping}
                glassMapping={productMappings.glassMapping}
                polyMapping={productMappings.polyMapping}
                aluminiumMapping={productMappings.aluminiumMapping}
                metalDeckMapping={productMappings.metalDeckMapping}
                steelHollowMapping={productMappings.steelHollowMapping}
                pvcGutterMapping={productMappings.pvcGutterMapping}
                flashingMapping={productMappings.flashingMapping}
                aluminumStripCeilingMapping={productMappings.aluminumStripCeilingMapping}
                addOnMapping={productMappings.addOnMapping}
                materialsMappingProp={materialsMappingForModal}
            />

            <BlueprintUploadModal
                addBlueprintModalState={addBlueprintModalState}
                resetAddBlueprintModal={resetAddBlueprintModal}
                isUploadingBlueprint={isUploadingBlueprint}
                handleBlueprintUpload={handleBlueprintUpload}
                setAddBlueprintModalState={setAddBlueprintModalState}
                orderProducts={orderData?.products || []}
            />

            {/* Approve Draft Modal */}
            {approveDraftModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setApproveDraftModalState(false);
                                setCommenceDate("");
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Approve Draft
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <p className="my-8 text-lg font-semibold text-gray-700">
                                        Are you sure you want to approve this draft?
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleApproveDraft();
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setApproveDraftModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reject Draft Modal */}
            {rejectDraftModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setRejectDraftModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Reject Draft
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <p className="my-8 text-lg font-semibold text-gray-700">
                                        Are you sure you want to reject this draft? The order status will be changed back to 'pending'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleRejectDraft();
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setRejectDraftModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Salesman Approve Modal */}
            {salesmanApproveModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setSalesmanApproveModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Salesman Approve
                                </h3>
                                <div className="updateProductDetailsContainer">
                                    <p>Are you sure you want to approve this draft? The order status will be changed to "pendingCustomerDraft".</p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleSalesmanApprove();
                                        }}
                                    >
                                        Confirm Approve
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setSalesmanApproveModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Salesman Reject Modal */}
            {salesmanRejectModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setSalesmanRejectModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Salesman Reject Draft
                                </h3>
                                <div className="updateProductDetailsContainer">
                                    <p>Are you sure you want to reject this draft? The order status will be changed back to "uploadedDraft".</p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer red"
                                        onClick={() => {
                                            handleSalesmanReject();
                                        }}
                                    >
                                        Confirm Reject
                                    </button>
                                    <button
                                        className="cancel pointer"
                                        onClick={() => {
                                            setSalesmanRejectModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Customer Approve Modal */}
            {customerApproveModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setCustomerApproveModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Customer Approve
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <p className="my-4 text-lg font-semibold text-gray-700">
                                        Please sign below to approve:
                                    </p>
                                </div>

                                {/* Signature Section */}
                                <div className="mt-4 mb-6">
                                    <div className="flex justify-between items-center mb-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Customer Signature:
                                        </label>
                                        <button
                                            type="button"
                                            onClick={clearCustomerSignature}
                                            className="px-3 py-1 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 transition-colors"
                                        >
                                            Clear Signature
                                        </button>
                                    </div>
                                    <div className="border-2 border-gray-300 rounded-lg p-4 bg-gray-50">
                                        <canvas
                                            ref={(ref) => setCustomerSignatureRef(ref)}
                                            width={typeof window !== 'undefined' && window.innerWidth <= 768 ? 600 : 400}
                                            height={typeof window !== 'undefined' && window.innerWidth <= 768 ? 300 : 150}
                                            className="border border-gray-400 bg-white rounded cursor-crosshair w-full"
                                            style={{ 
                                                maxWidth: "100%", 
                                                height: "auto",
                                                minHeight: typeof window !== 'undefined' && window.innerWidth <= 768 ? "300px" : "150px"
                                            }}
                                            onMouseDown={(e) => {
                                                const canvas = e.target;
                                                const rect = canvas.getBoundingClientRect();
                                                const ctx = canvas.getContext("2d");
                                                let isDrawing = false;

                                                const startDrawing = (e) => {
                                                    isDrawing = true;
                                                    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
                                                    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
                                                    ctx.beginPath();
                                                    ctx.moveTo(x, y);
                                                };

                                                const draw = (e) => {
                                                    if (!isDrawing) return;
                                                    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
                                                    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
                                                    ctx.lineWidth = 2;
                                                    ctx.lineCap = "round";
                                                    ctx.strokeStyle = "#000";
                                                    ctx.lineTo(x, y);
                                                    ctx.stroke();
                                                    ctx.beginPath();
                                                    ctx.moveTo(x, y);
                                                };

                                                const stopDrawing = () => {
                                                    isDrawing = false;
                                                };

                                                startDrawing(e);

                                                const handleMouseMove = (e) => draw(e);
                                                const handleMouseUp = () => {
                                                    stopDrawing();
                                                    document.removeEventListener("mousemove", handleMouseMove);
                                                    document.removeEventListener("mouseup", handleMouseUp);
                                                };

                                                document.addEventListener("mousemove", handleMouseMove);
                                                document.addEventListener("mouseup", handleMouseUp);
                                            }}
                                            onTouchStart={(e) => {
                                                const canvas = e.target;
                                                const rect = canvas.getBoundingClientRect();
                                                const ctx = canvas.getContext("2d");
                                                const touch = e.touches[0];
                                                let isDrawing = false;

                                                const startDrawing = (touch) => {
                                                    isDrawing = true;
                                                    const x = (touch.clientX - rect.left) * (canvas.width / rect.width);
                                                    const y = (touch.clientY - rect.top) * (canvas.height / rect.height);
                                                    ctx.beginPath();
                                                    ctx.moveTo(x, y);
                                                };

                                                const draw = (touch) => {
                                                    if (!isDrawing) return;
                                                    const x = (touch.clientX - rect.left) * (canvas.width / rect.width);
                                                    const y = (touch.clientY - rect.top) * (canvas.height / rect.height);
                                                    ctx.lineWidth = 2;
                                                    ctx.lineCap = "round";
                                                    ctx.strokeStyle = "#000";
                                                    ctx.lineTo(x, y);
                                                    ctx.stroke();
                                                    ctx.beginPath();
                                                    ctx.moveTo(x, y);
                                                };

                                                const stopDrawing = () => {
                                                    isDrawing = false;
                                                };

                                                startDrawing(touch);

                                                const handleTouchMove = (e) => {
                                                    e.preventDefault();
                                                    if (e.touches[0]) draw(e.touches[0]);
                                                };
                                                const handleTouchEnd = (e) => {
                                                    e.preventDefault();
                                                    stopDrawing();
                                                    canvas.removeEventListener("touchmove", handleTouchMove);
                                                    canvas.removeEventListener("touchend", handleTouchEnd);
                                                };

                                                canvas.addEventListener("touchmove", handleTouchMove);
                                                canvas.addEventListener("touchend", handleTouchEnd);
                                            }}
                                        />
                                        <p className="text-xs text-gray-500 mt-2 text-center">
                                            Draw your signature above using your mouse or touch
                                        </p>
                                    </div>
                                </div>

                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleCustomerApprove();
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setCustomerApproveModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Customer Reject Modal */}
            {customerRejectModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setCustomerRejectModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Customer Reject Draft
                                </h3>
                                <div className="updateProductDetailsContainer">
                                    <p>Are you sure you want to reject this draft on behalf of the customer? The order status will be changed back to "uploadedDraft".</p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer red"
                                        onClick={() => {
                                            handleCustomerReject();
                                        }}
                                    >
                                        Confirm Reject
                                    </button>
                                    <button
                                        className="cancel pointer"
                                        onClick={() => {
                                            setCustomerRejectModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Approve Production Modal */}
            {approveProductionModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setApproveProductionModalState(false);
                                setProductionCommenceDate("");
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Approve Production
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <p className="my-8 text-lg font-semibold text-gray-700">
                                        Are you sure you want to approve production? The approval date will be set to today.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleApproveProduction();
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setApproveProductionModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reject Production Modal */}
            {rejectProductionModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setRejectProductionModalState(false);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Reject Production
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to reject production? This will change the order status back to 'purchasing'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer red"
                                        onClick={() => {
                                            handleRejectProduction();
                                        }}
                                    >
                                        Confirm Reject
                                    </button>
                                    <button
                                        className="cancel pointer"
                                        onClick={() => {
                                            setRejectProductionModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Approve Installation Modal */}
            {approveInstallationModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setApproveInstallationModalState(false);
                                setInstallationCommenceDate("");
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Approve Installation
                                </h3>

                                <div className="flex flex-col items-center mb-4">
                                    <p className="my-8 text-lg font-semibold text-gray-700">
                                        Are you sure you want to approve installation? The approval date will be set to today.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleApproveInstallation();
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setApproveInstallationModalState(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Submit Draft Confirmation Modal */}
            {submitDraftModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setSubmitDraftModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Submit Draft
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to submit the draft? This will change the order status to 'uploadedDraft'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmSubmitDraft}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setSubmitDraftModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Submit Purchase Order Confirmation Modal */}
            {submitPurchaseOrderModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setSubmitPurchaseOrderModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Submit Purchase Order
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to submit the purchase order? This will change the order status to 'Purchase Approved'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmSubmitPurchaseOrder}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setSubmitPurchaseOrderModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* Reject Purchase Order Confirmation Modal */}
            {rejectPurchaseOrderModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setRejectPurchaseOrderModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Reject Purchase Order
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to reject the purchase order? This will change the order status back to 'pending'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmRejectPurchaseOrder}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setRejectPurchaseOrderModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Complete Purchase Confirmation Modal */}
            {completePurchaseModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setCompletePurchaseModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Purchase Completed
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to mark the purchase as completed? This will finalize the purchasing step and allow production to proceed.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmCompletePurchase}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setCompletePurchaseModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Submit Production Confirmation Modal */}
            {submitProductionModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setSubmitProductionModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Submit Production
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to submit for production? This will change the order status to 'production'.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmSubmitProduction}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setSubmitProductionModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Complete Production Confirmation Modal */}
            {completeProductionModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setCompleteProductionModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Production Complete
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to mark production as complete? Once confirmed, you will need to do a final confirmation before proceeding.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmCompleteProduction}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setCompleteProductionModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirm PO Arrived Modal */}
            {confirmPOArrivedModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setConfirmPOArrivedModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Purchase Order Arrived
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Has the purchase order arrived? This will complete the purchasing step and allow production to proceed.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmPOArrived}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setConfirmPOArrivedModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirm Production Completed Modal */}
            {confirmProductionCompletedModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setConfirmProductionCompletedModalState(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Production Completed
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure production is fully completed? This will finalize the production step and allow installation to proceed.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmProductionCompleted}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => setConfirmProductionCompletedModalState(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Blueprint Confirmation Modal */}
            {deleteBlueprintModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setDeleteBlueprintModalState(false);
                                setDeleteBlueprintData(null);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Delete Blueprint
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <p className="text-center text-lynch mb-4">
                                        Are you sure you want to delete this blueprint? This action cannot be undone.
                                    </p>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={confirmDeleteBlueprint}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setDeleteBlueprintModalState(false);
                                            setDeleteBlueprintData(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
